import { useState, useEffect,useRef  } from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import { mainTable } from "../css/Common";
import Buttons from "../components/Buttons";
import AddScreenTitle from "../components/AddScreenTitle";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import {
  enquiryHeaders,
  BookingDetailsHeaders,
} from "../components/HeaderAttribute";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import Enquirypopup from "../popup-containers/Enquirypopup";
import PopUpButtons from "../components/PopUpButtons";
import { useNavigate } from "react-router-dom";
import OnLostPopUp from "../popup-containers/onLostPopUp";
import ConfirmBookingPopUp from "../popup-containers/ConfirmBookingPopUp";
import OnHoldPopUp from "../popup-containers/onHoldPopUp";
import { IUDAPI, BindPostAPI } from "../services/APIConnection";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import toast from "react-hot-toast";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import Cancelpopup from "../popup-containers/Cancelpopup";
import Loader from "../ReusableComponents/Loader";

const Enquiry = () => {
  const today = new Date().toISOString().split("T")[0];
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    number: "",
    enquirydate: today,
    enquiryid: "ENQ",
    enquirytype: "",
    fromdate: "",
    todate: "",
    state: "",
    country: "",
    pincode: "",
    email:"",
    city: "",
    streetdoorno: "",
    statename:"",
    cityname:"",
    area: "",
    idproof: "",
    idvalue: "",
    noofdays: "",
    sourcetype: "",
    source: "",
    referralcontact: "",
    roomtype: [],
    basictariff: "",
    specialtariff: "",
    amountpaid: "",
  });
const topRef = useRef(null);
  const [lost, setLost] = useState(false);
  const [onBook, setOnBook] = useState(false);
  const [hold, setHold] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [childId, setChildId] = useState(false);
  const [errors, setErrors] = useState({
    fname: "",
    lname: "",
    number: "",

    villaname: "",
    villatype: "",
    enquirydate: "",
    enquiryid: "",
    enquirytype: "",
    fromdate: "",
    todate: "",
    amount: "",
  });

  const [popUpData, setPopUpData] = useState([]);

  const [iddropdown, setiddropdown] = useState([]);

  const [referralsource, setreferralsource] = useState([]);
  const [roomtype, setroomtype] = useState([]);
  const [enquirytypedropdown, setenquirydropdown] = useState([]);

  const [lostreasondropdown, setlostreasondropdown] = useState([
    // { value: '1', label: 'Price' },
    // { value: '2', label: 'Room not available' },
    // { value: '3', label: 'facility not as per need' },
  ]);

  const [confirm1, setConfirmRecord1] = useState("");
  const [confirm2, setConfirmRecord2] = useState([]);

  const [countrydropdown, setCountrydropdown] = useState([]);

  const [statedropdown, setStatedropdown] = useState([]);
  const [citydropdown, setcitydropdown] = useState([]);
  const [paymentType, setPaymentType] = useState([]);

  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [onSubmit, setOnSubmit] = useState(false);
  const [viewPopUp, setViewPopUp] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);

  //booking confirm

  const [popUpBookOpen, setpopUpBookOpen] = useState();
  const [popUpLostOpen, setpopUpLostOpen] = useState();
  const [popUpHoldOpen, setpopUpHoldOpen] = useState();
  const [popUpCancelOpen, setpopUpCancelOpen] = useState();

  const [tableData, setTableData] = useState([{}]);

  const [bindEnquiryData, setBindEnquiryData] = useState([]);
  const [bindenquiryChildData, setbindenquiryChildData] = useState([]);

  const [bindBookingData, setBindBookingData] = useState([]);

  const [popUpOpen, setpopUpOpen] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [rowIndex, setRowIndex] = useState(null);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);

  const [confirm, setConfirmRecord] = useState("");
  const [confirmBookingFlag, setConfirmBookingFlag] = useState(1);

  const [holdrecord, setHoldRecord] = useState("");
  const [lostRecord, setLostRecord] = useState("");

  const [TxnEnquiryId, setTxnEnquiryId] = useState("");

  const [selectedRecord, setSelectedRecord] = useState({});
  const [tableErrors, setTableErrors] = useState([]);
  const [tableErrorMessages, setTableErrorMessages] = useState([]);
  const [holdreasondropdown, setholdreasondropdown] = useState([]);

  useEffect(() => {
    const { fromdate, todate } = formData;

    if (fromdate && todate) {
      const from = new Date(fromdate);
      const to = new Date(todate);
      const diffTime = to - from;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      setFormData((prev) => ({
        ...prev,
        noofdays: diffDays >= 0 ? diffDays.toString() : "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        noofdays: "",
      }));
    }
  }, [formData.fromdate, formData.todate]);

  useEffect(() => {
    if (!bindEnquiryData || !bindEnquiryData[rowIndex]) return;

    const enquiry = bindEnquiryData[rowIndex];

    const getDropdownValue = (dropdown, id, label = "Unknown") => {
      const found = dropdown.find((item) => item.value === id);
      return { value: id, label: found ? found.label : label };
    };

    const enquiryType = getDropdownValue(
      enquirytypedropdown,
      enquiry.MstEnquiryTypeId
    );
    const countryValue = getDropdownValue(
      countrydropdown,
      enquiry.MstCountryId
    );
    const stateValue = getDropdownValue(statedropdown, enquiry.MstStateId);
    const cityValue = getDropdownValue(citydropdown, enquiry.MstCityId);
    const sourceType = getDropdownValue(referralsource, enquiry.MstSourceId);
    const idproofValue = getDropdownValue(iddropdown, enquiry.MstIdProofId);

    const dropdownvalues = [
      [enquiryType],
      [countryValue],
      [stateValue],
      [cityValue],
      [sourceType],
      [idproofValue],
    ];

    setPopUpData(dropdownvalues);
  }, [
    bindEnquiryData,
    rowIndex,
    enquirytypedropdown,
    countrydropdown,
    statedropdown,
    citydropdown,
    referralsource,
    iddropdown,
    lostreasondropdown,
    holdreasondropdown,
  ]);
  console.log("Popupdata", popUpData);

  useEffect(() => {
    const total = tableData.reduce(
      (sum, row) => sum + (Number(row.amount) || 0),
      0
    );

    setFormData((prev) => ({
      ...prev,
      amountpaid: total,
    }));
  }, [tableData]);

  ////////////////////useeffect//////////////
  const handleInputChangeForm = (eOrValue, maybeName) => {
    let name, value;

    if (eOrValue && eOrValue.target) {
      // It's a normal input event
      ({ name, value } = eOrValue.target);
    } else {
      // It's a direct call from a custom component
      name = maybeName;
      value = eOrValue;
    }

    if (name === "pincode") {
      const onlyNumbers = /^[0-9]{0,6}$/; // allows 0 to 6 digits (no letters)

      if (!onlyNumbers.test(value)) {
        return; // Ignore invalid input
      }
    }

    if (name === "referralcontact") {
      const isValid = /^[0-9]*$/.test(value);

      if (!isValid && value.length <= 15) {
        return;
      }
    }

    if (name === "number") {
      const isValid = /^[0-9]*$/.test(value);

      if (!isValid && value.length <= 15) {
        return;
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleUserFieldsChange = (value, name) => {
    //
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const fieldLabels = {
    fname: { label: "First Name", type: "text" },
    lname: { label: "Last Name", type: "text" },
    fromdate: { label: "Booking From", type: "date" },
    todate: { label: "Booking To", type: "date" },
    enquirytype: { label: "Enquiry Type", type: "select-one" },
    enquirydate: { label: "Enquiry Date", type: "date" },
    number: { label: "Mobile Number", type: "text" },
    // Add more fields here as needed
  };

  const typelabel = [
    { name: "fname", label: "First Name", type: "text" },
    { name: "lname", label: "Last Name", type: "text" },
    { name: "fromdate", label: "Booking From", type: "date" },
    { name: "todate", label: "Booking To", type: "date" },
  ];

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const field = fieldLabels[name];
    if (!field) return;

    const label = field.label;
    const type = field.type;

    let message = "";

    if (value.trim() === "") {
      message = type === "select-one" ? `Select ${label}` : `Enter ${label}`;
    } else {
      // ✅ Future date validation
      if ((name === "fromdate" || name === "todate") && value) {
        const today = new Date().toISOString().split("T")[0];
        if (value < today) {
          message = `${label} cannot be a past date`;
        }
      }
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: message,
    }));
  };

  const createdBy = sessionStorage.getItem("createdBy");

  const navigate = useNavigate();

  const validateForm = (action) => {
    let formValid = true;
    const newErrors = {};
    let fieldsToValidate = [];

    if (action === "save") {
      fieldsToValidate = ["fname", "enquirytype", "number", "fromdate", "todate","RoomTypeId","AvailableRooms","Tariff","specialtariff","numberofadults","Numberofrooms","numberofchildren"];
    }

    // fieldsToValidate.forEach((key) => {
    //   const value = formData[key] || "";
    //   const field = fieldLabels[key];

    //   if (!field) return; // skip unknown fields

    fieldsToValidate.forEach((key) => {
      const rawValue = formData[key];
      const value =
        rawValue !== undefined && rawValue !== null
          ? String(rawValue)
          : "";
  
      const field = fieldLabels[key];
      if (!field) return;

      const { label, type } = field;

      if (value.trim() === "") {
        const message =
          type === "select-one" ? `Select ${label}` : `Enter ${label}`;
        newErrors[key] = message;
        formValid = false;
      } else {
        // ✅ Additional future-date validation
        if (
          (key === "fromdate" || key === "todate") &&
          value &&
          addScreenTitle
        ) {
          const today = new Date().toISOString().split("T")[0];
          if (value < today) {
            newErrors[key] = `${label} cannot be a past date`;
            formValid = false;
          }
        }

        // ✅ Check if Booking To is >= Booking From
        if (key === "todate" && formData.fromdate && value) {
          if (value < formData.fromdate) {
            newErrors[key] = `${label} cannot be earlier than Booking From`;
            formValid = false;
          }
        }
      }
    });
    setErrors(newErrors);
    return formValid;
  };

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    BindEnquiryTableData();

    setFormData({
      fname: "",
      lname: "",
      number: "",
      villaname: "",
      enquirydate: new Date(),
      country:1,
      enquiryid: "ENQ",
      enquirytype: "",
      villatype: "",
      fromdate: "",
      todate: "",
      villaselect: [],
      amount: "",
      lostreason: "",
      sourcetype: "",
      idproof: "",
    });
  };
  const cancel = () => {
    topRef.current?.scrollIntoView({ behavior: "smooth" });
    setVisibleAdd(false);
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setpopUpOpen(false);
    setpopUpBookOpen(false);
    setConfirmRecord("");
    setLostRecord("");
    setHoldRecord("");
    setpopUpHoldOpen(false);
    setpopUpLostOpen(false);
    setpopUpCancelOpen(false);
    BindEnquiryTableData();
    setSubmitBtnDisabled(false);
    setTxnEnquiryId("");
    setIsLoading(false);
    setTableErrorMessages([]); 
    setErrors({
      fname: "",
      lname: "",
      number: "",
      email: "",
      pincode: "",
      city: "",
      street: "",
      door: "",
      country: "",
      state: "",
      district: "",
      statename:"",
      cityname:"",
      villaname: "",
      villatype: "",
      enquirydate: "",
      enquiryid: "ENQ",
      enquirytype: "",
      fromdate: "",
      todate: "",
      adults: "",
      children: "",
      idproof: "",
      idvalue: "",
      amount: "",
      lostreason: "",
      sourcetype: "",
    });

    setTableData([
      {
        AvailableRooms: "",
        numberofadults: "",
        numberofchildren: "",
        RoomsType: "",
        Tariff: "",
        RoomTypeId: "",
      },
    ]);
    
  };
  const onConfirmBookingSubmit = async (items, flag) => {
    const isValid = validateForm("save");
  
    if (isValid && validateTableData()) {
      setIsOpen(false);
      setIsLoading(true);
      setSubmitBtnDisabled(true);
  
      const filteredTableData = tableData.filter(
        (row) => row.RoomTypeId && row.RoomTypeId !== ""
      );
  
      const data = {
        txnEnquiryId: TxnEnquiryId ? TxnEnquiryId : 0,
        enquiryNo: "ENQ",
        mstClientId: clientId,
        enquiryDate: formData.enquirydate,
        mstEnquiryTypeId: formData.enquirytype || 0,
        bookingFrom: formData.fromdate,
        bookingTo: formData.todate,
        noOfDays: formData.noofdays || 0,
        firstName: formData.fname || "",
        lastName: formData.lname || "",
        mobileNumber: formData.number || "",
        mstCountryId: formData.country || 0,
        mstStateId: parseInt(formData.state) || 0,
        city: formData.city ? formData.city : 0,
        stateName: formData.statename || "",
        cityName: formData.cityname || "",
        streetDoorNo: formData.streetdoorno || "",
        area: formData.area || "",
        pincode: formData.pincode || "",
        mstSourceTypeId: formData.sourcetype || 0,
        contactNumber: formData.referralcontact || "",
        mstIdProofId: formData.idproof || 0,
        idNumber: formData.idvalue || "",
        email: formData.email || "",
        source: formData.source || "",
        amount: formData.amountpaid || 0,
        mstEnquiryStatusId: "1" || 0,
        createdBy: createdBy,
        flag: flag,
        enquiryChild: JSON.stringify(filteredTableData),
      };
  
      const response = await IUDAPI(data, "Enquiry/IUDEnquiryWithBooking");
  
      if (flag == 1) {
        if (response.data.Table[0].Result === "S") {
          const enquiryResponse = response.data.Table1[0];
          
          // Create confirmation data with same structure as onConfirmBooking
          const confirmationData = {
            // Enquiry/Booking basic info
            EnquiryDate: enquiryResponse.EnquiryDate || formData.enquirydate,
            EnquiryNo: enquiryResponse.EnquiryNo || "ENQ",
            BookingNo: enquiryResponse.BookingNo || null,
            BookingFrom: enquiryResponse.BookingFrom || formData.fromdate,
            BookingTo: enquiryResponse.BookingTo || formData.todate,
            NoOfDays: enquiryResponse.NoOfDays || formData.noofdays,
            
            // Customer details with BookingPerson prefix (as expected by ConfirmBookingPopUp)
            BookingPersonFirstName: enquiryResponse.FirstName || formData.fname,
            BookingPersonLastName: enquiryResponse.LastName || formData.lname,
            BookingPersonMobileNumber: enquiryResponse.MobileNumber || formData.number,
            BookingPersonMstCountryId: enquiryResponse.MstCountryId || formData.country,
            BookingPersonMstStateId: enquiryResponse.MstStateId || formData.state,
            BookingPersonMstCityId: enquiryResponse.MstCityId || formData.city,
            BookingPersonStreetDoorNo: enquiryResponse.StreetDoorNo || formData.streetdoorno,
            BookingPersonArea: enquiryResponse.Area || formData.area,
            BookingPersonPincode: enquiryResponse.Pincode || formData.pincode,
            BookingContactNumber: enquiryResponse.ContactNumber || formData.referralcontact,
            
            // Additional fields
            Email: enquiryResponse.Email || formData.email,
            MstSourceId: enquiryResponse.MstSourceId || formData.sourcetype,
            Source: enquiryResponse.Source || formData.source,
            MstIdProofId: enquiryResponse.MstIdProofId || formData.idproof,
            IdNumber: enquiryResponse.IdNumber || formData.idvalue,
            
            // Amount fields
            TotalAmount: enquiryResponse.TotalAmount || formData.amountpaid,
            ReceivedAmount: enquiryResponse.ReceivedAmount || 0,
            BalanceAmount: enquiryResponse.BalanceAmount || formData.amountpaid,
            PaymentType: enquiryResponse.PaymentType || "",
            PaymentRefNumber: enquiryResponse.PaymentRefNumber || null,
            ShowImage: enquiryResponse.ShowImage || null,
          };
          
          setConfirmRecord(confirmationData);
          
          const drpdetailsData = [
            countrydropdown,
            statedropdown,
            referralsource,
            iddropdown,
            roomtype,
            paymentType,
            citydropdown,
          ];
          setConfirmRecord1(drpdetailsData);
          
          const groupedTable = {};
          response.data.Table2.forEach((item) => {
            const key = item.MstRoomTypeId || item.RoomType;
            if (!groupedTable[key]) {
              groupedTable[key] = item;
            }
          });
  
          const roomTableDetailsData = Object.values(groupedTable).map((item) => ({
            RoomTypeId: item.MstRoomTypeId,
            RoomType: item.RoomType,
            RoomId: item.RoomId,
            AvailableRoomsId: "",
            AvailableRoomsName: "",
            AvailableRooms: item.NoOfAvailableRooms,
            Numberofrooms: item.NoOfRequiredRooms,
            NumberofEnquiryRooms: item.NoOfRequiredRooms,
            numberofadults: item.NoOfAdults,
            numberofchildren: item.NoOfChildren,
            Tariff: item.BasicTariff,
            specialtariff: item.SpecialTariff,
            amount: item.Amount,
            Photo: item.Photo,
            Size: item.Size,
            MaxOccupancy: item.MaxOccupancy,
            Bedrooms: item.Bedrooms,
            Balcony: item.Balcony,
            LivingRoom: item.LivingRoom,
            SpaceDetails: item.SpaceDetails,
            AmenitiesDetails: item.AmenitiesDetails,
          }));
  
          handleDeleteRow(0);
          setConfirmRecord2(roomTableDetailsData);
  
          const fromDate = toYMD(enquiryResponse.BookFrom || formData.fromdate);
          const toDate = toYMD(enquiryResponse.BookTo || formData.todate);
  
          for (let i = 0; i < roomTableDetailsData.length; i++) {
            const row = roomTableDetailsData[i];
            if (!row.RoomTypeId) continue;
  
            try {
              const postData = {
                mstRoomTypeId: row.RoomTypeId,
                fromDate: fromDate,
                toDate: toDate,
                mstClientId: clientId,
              };
  
              const roomResponse = await BindPostAPI(
                postData,
                "Enquiry/BindGetRoomDetails"
              );
              const apiRow = roomResponse?.data?.Table?.[0];
  
              if (apiRow) {
                row.AvailableRoomsId = apiRow.AvailableRoomsId ?? "";
                row.AvailableRooms = apiRow.AvailableRooms ?? null;
                row.AvailableRoomsName = apiRow.AvailableRoomsName ?? "";
              } else {
                row.AvailableRoomsId = "";
                row.AvailableRooms = null;
                row.AvailableRoomsName = "";
              }
            } catch (err) {
              console.error(`RoomTypeId ${row.RoomTypeId} failed:`, err);
              row.AvailableRoomsId = "";
              row.AvailableRooms = null;
              row.AvailableRoomsName = "";
            }
          }
  
          setTableData([...roomTableDetailsData]);
          setpopUpBookOpen(true);
        } else {
          toast.error("Failed to book room", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      }
      setIsLoading(false);
    } else {
      setIsOpen(true);
      setIsLoading(false);
      setSubmitBtnDisabled(false);
    }
  };

  // const onConfirmBookingSubmit = async (items, flag) => {
  //   const isValid = validateForm("save");

  //   if (isValid) {
  //     setIsOpen(false);
  //     //setIsLoading(true);
  //     setSubmitBtnDisabled(true);

  //     const data = {
  //       txnEnquiryId: TxnEnquiryId ? TxnEnquiryId : 0,
  //       enquiryNo: "ENQ" || bindEnquiryData[rowIndex].TxnEnquiryId,
  //       mstClientId: clientId,
  //       enquiryDate: formData.enquirydate,
  //       mstEnquiryTypeId: formData.enquirytype || 0,
  //       bookingFrom: formData.fromdate,
  //       bookingTo: formData.todate,
  //       noOfDays: formData.noofdays || 0,
  //       //done
  //       firstName: formData.fname || "",
  //       lastName: formData.lname || "",
  //       mobileNumber: formData.number || "",
  //       //done
  //       mstCountryId: formData.country || 0,
  //       mstStateId: formData.state || 0,
  //       city: formData.city || 0,
  //       streetDoorNo: formData.streetdoorno || "",
  //       area: formData.area || "",
  //       pincode: formData.pincode || "",
  //       mstSourceTypeId: formData.sourcetype || 0,
  //       contactNumber: formData.referralcontact || "",
  //       mstIdProofId: formData.idproof || 0,

  //       idNumber: formData.idvalue || "",
  //       email: formData.email || "",
  //       source: formData.source || "",

  //       //belowdone
  //       amount: formData.amountpaid || 0,
  //       mstEnquiryStatusId: "1" || 0,
  //       createdBy: createdBy,
  //       flag: flag,
  //       enquiryChild: JSON.stringify(tableData),
  //       //enquiryChild: '[{ \"mstRoomTypeId\": 1, \"mstRoomId\": 2, \"noOfAvailableRooms\": 2, \"basicTariff\": 2500, \"specialTariff\": 500, \"noOfRequiredRooms\": 1, \"noOfAdults\": 1, \"noOfChildren\": 2, \"amount\": 3500, \"mstEnquiryStatusId\": 1, \"mstHoldReasonId\": 0, \"holdFollowUpDate\": \"2025-07-11\", \"mstHoldReasonNotes\": \"Some note\", \"mstLostReasonId\": 0, \"lostReasonNotes\": \"Another note\" }]'
  //     };
  //     console.log(tableData);

  //     const response = await IUDAPI(data, "Enquiry/IUDEnquiryWithBooking");

  //     if (flag == 1) {
  //       //if flag ==1 , add
  //       if (response.data.Table[0].Result === "S") {
  //         setConfirmRecord(response.data.Table1[0]);
  //         const drpdetailsData = [
  //           countrydropdown,
  //           statedropdown,
  //           referralsource,
  //           iddropdown,
  //           roomtype,
  //           paymentType,
  //           citydropdown,
  //         ];
  //         setConfirmRecord1(drpdetailsData);
  //         const groupedTable = {};
  //         response.data.Table2.forEach((item) => {
  //           const key = item.MstRoomTypeId || item.RoomType;
  //           if (!groupedTable[key]) {
  //             groupedTable[key] = item;
  //           }
  //         });

  //         // Step 3: Create base roomTableDetailsData with everything from enquiry child
  //         const roomTableDetailsData = Object.values(groupedTable).map(
  //           (item) => ({
  //             RoomTypeId: item.MstRoomTypeId,
  //             RoomType: item.RoomType,
  //             RoomId: item.RoomId,
  //             AvailableRoomsId: "", // will be fetched
  //             AvailableRoomsName: "",
  //             AvailableRooms: item.NoOfAvailableRooms, // will be fetched
  //             Numberofrooms: item.NoOfRequiredRooms,
  //             numberofadults: item.NoOfAdults,
  //             numberofchildren: item.NoOfChildren,
  //             Tariff: item.BasicTariff,
  //             specialtariff: item.SpecialTariff,
  //             amount: item.Amount,
  //             Photo: item.Photo,
  //             Size: item.Size,
  //             MaxOccupancy: item.MaxOccupancy,
  //             Bedrooms: item.Bedrooms,
  //             Balcony: item.Balcony,
  //             LivingRoom: item.LivingRoom,
  //             SpaceDetails: item.SpaceDetails,
  //             AmenitiesDetails: item.AmenitiesDetails,
  //           })
  //         );

  //         // Step 4: Show popup now, will fill data next
  //         handleDeleteRow(0);
  //         setConfirmRecord2(roomTableDetailsData); // temporary without availableRooms

  //         const fromDate = toYMD(response.data.Table1[0].BookFrom); // "2025-08-01"; // or use dynamic: toYMD(value.BookFrom)
  //         const toDate = toYMD(response.data.Table1[0].BookTo); //"2025-08-05"; // or use dynamic: toYMD(value.BookTo)

  //         for (let i = 0; i < roomTableDetailsData.length; i++) {
  //           const row = roomTableDetailsData[i];
  //           if (!row.RoomTypeId) continue;

  //           try {
  //             const postData = {
  //               mstRoomTypeId: row.RoomTypeId,
  //               fromDate: fromDate,
  //               toDate: toDate,
  //               mstClientId: clientId,
  //             };

  //             const response = await BindPostAPI(
  //               postData,
  //               "Enquiry/BindGetRoomDetails"
  //             );
  //             const apiRow = response?.data?.Table?.[0];

  //             if (apiRow) {
  //               row.AvailableRoomsId = apiRow.AvailableRoomsId ?? "";
  //               row.AvailableRooms = apiRow.AvailableRooms ?? null;
  //               row.AvailableRoomsName = apiRow.AvailableRoomsName ?? "";
  //             } else {
  //               row.AvailableRoomsId = "";
  //               row.AvailableRooms = null;
  //               row.AvailableRoomsName =  "";
  //             }
  //           } catch (err) {
  //             console.error(`RoomTypeId ${row.RoomTypeId} failed:`, err);
  //             row.AvailableRoomsId = "";
  //             row.AvailableRooms = null;
  //             row.AvailableRoomsName =  "";
  //           }
  //         }

  //         // Step 6: Push final tableData with AvailableRooms
  //         setTableData([...roomTableDetailsData]);

  //         setpopUpBookOpen(true);
  //         // toast.success("Room booking successful", {
  //         //   duration: 3000,
  //         //   position: "top-center",
  //         // });
  //         // setTimeout(cancel, 3000);
  //       } else {
  //         toast.error("Failed to book room", {
  //           duration: 3000,
  //           position: "top-center",
  //         });
  //         setTimeout(cancel, 3000);
  //       }
  //     }
  //     if (flag == 2) {
  //       //if flag ==1 , add
  //       if (response.data.Table[0].Result === "M") {
  //         setConfirmRecord(response.data.Table1[0]);
  //         const drpdetailsData = [
  //           countrydropdown,
  //           statedropdown,
  //           referralsource,
  //           iddropdown,
  //           roomtype,
  //           paymentType,
  //           citydropdown,
  //         ];
  //         setConfirmRecord1(drpdetailsData);
  //         const groupedTable = {};
  //         response.data.Table2.forEach((item) => {
  //           const key = item.MstRoomTypeId || item.RoomType;
  //           if (!groupedTable[key]) {
  //             groupedTable[key] = item;
  //           }
  //         });

  //         // Step 3: Create base roomTableDetailsData with everything from enquiry child
  //         const roomTableDetailsData = Object.values(groupedTable).map(
  //           (item) => ({
  //             RoomTypeId: item.MstRoomTypeId,
  //             RoomType: item.RoomType,
  //             RoomId: item.RoomId,
  //             AvailableRoomsId: "", // will be fetched
  //             AvailableRooms: item.NoOfAvailableRooms, // will be fetched
  //             Numberofrooms: item.NoOfRequiredRooms,
  //             numberofadults: item.NoOfAdults,
  //             numberofchildren: item.NoOfChildren,
  //             Tariff: item.BasicTariff,
  //             specialtariff: item.SpecialTariff,
  //             amount: item.Amount,
  //             Photo: item.Photo,
  //             Size: item.Size,
  //             MaxOccupancy: item.MaxOccupancy,
  //             Bedrooms: item.Bedrooms,
  //             Balcony: item.Balcony,
  //             LivingRoom: item.LivingRoom,
  //             SpaceDetails: item.SpaceDetails,
  //             AmenitiesDetails: item.AmenitiesDetails,
  //           })
  //         );

  //         // Step 4: Show popup now, will fill data next
  //         handleDeleteRow(0);
  //         setConfirmRecord2(roomTableDetailsData); // temporary without availableRooms

  //         const fromDate = toYMD(response.data.Table1[0].BookFrom); // "2025-08-01"; // or use dynamic: toYMD(value.BookFrom)
  //         const toDate = toYMD(response.data.Table1[0].BookTo); //"2025-08-05"; // or use dynamic: toYMD(value.BookTo)

  //         for (let i = 0; i < roomTableDetailsData.length; i++) {
  //           const row = roomTableDetailsData[i];
  //           if (!row.RoomTypeId) continue;

  //           try {
  //             const postData = {
  //               mstRoomTypeId: row.RoomTypeId,
  //               fromDate: fromDate,
  //               toDate: toDate,
  //               mstClientId: clientId,
  //             };

  //             const response = await BindPostAPI(
  //               postData,
  //               "Enquiry/BindGetRoomDetails"
  //             );
  //             const apiRow = response?.data?.Table?.[0];

  //             if (apiRow) {
  //               row.AvailableRoomsId = apiRow.AvailableRoomsId ?? "";
  //               row.AvailableRooms = apiRow.AvailableRooms ?? null;
  //             } else {
  //               row.AvailableRoomsId = "";
  //               row.AvailableRooms = null;
  //             }
  //           } catch (err) {
  //             console.error(`RoomTypeId ${row.RoomTypeId} failed:`, err);
  //             row.AvailableRoomsId = "";
  //             row.AvailableRooms = null;
  //           }
  //         }

  //         // Step 6: Push final tableData with AvailableRooms
  //         setTableData([...roomTableDetailsData]);

  //         setpopUpBookOpen(true);
  //         // toast.success("Room booking successful", {
  //         //   duration: 3000,
  //         //   position: "top-center",
  //         // });
  //         // setTimeout(cancel, 3000);
  //       } else {
  //         toast.error("Failed to book room", {
  //           duration: 3000,
  //           position: "top-center",
  //         });
  //         setTimeout(cancel, 3000);
  //       }
  //     }
  //   }
  // };
  var clientId = sessionStorage.getItem("MstClientId");
  const handleSubmit = async (items, flag) => {
    debugger;
    setIsLoading(true);
    setTableErrors([]);
    setTableErrorMessages([]); 
    const isValid = validateForm("save"); // Validate only save fields
    
    if (flag == 1 || flag == 2) {
      if (!isValid) {
        setIsOpen(true);
        setIsLoading(false);
        setSubmitBtnDisabled(false);
      }
      if (validateTableData()) {
    // Proceed to submit
  
      if (isValid) {
        setIsOpen(false);
        setIsLoading(true);
        setSubmitBtnDisabled(true);
        const filteredTableData = tableData.filter(
          (row) => row.RoomTypeId && row.RoomTypeId !== ""
        );
        const data = {
          txnEnquiryId: TxnEnquiryId ? TxnEnquiryId : 0,
          enquiryNo: "ENQ" || bindEnquiryData[rowIndex].TxnEnquiryId,
          mstClientId: clientId,
          enquiryDate: formData.enquirydate,
          mstEnquiryTypeId: formData.enquirytype || 0,
          bookingFrom: formData.fromdate,
          bookingTo: formData.todate,
          noOfDays: formData.noofdays || 0,
          //done
          firstName: formData.fname || "",
          lastName: formData.lname || "",
          mobileNumber: formData.number || "",
          //done
          mstCountryId: formData.country || 0,
          mstStateId: parseInt(formData.state)|| 0,
          city: formData.city? formData.city: 0,

          stateName:formData.statename || "",
          cityName:formData.cityname || "",
          streetDoorNo: formData.streetdoorno || "",
          area: formData.area || "",
          pincode: formData.pincode || "",
          mstSourceTypeId: formData.sourcetype || 0,
          contactNumber: formData.referralcontact || "",
          mstIdProofId: formData.idproof || 0,
          
          idNumber: formData.idvalue || "",
          email:formData.email || "",
          source: formData.source || "",

          //belowdone
          amount: formData.amountpaid || 0,
          mstEnquiryStatusId: "1" || 0,
          createdBy: createdBy,
          flag: flag,
          enquiryChild: JSON.stringify(filteredTableData),
          //enquiryChild: '[{ \"mstRoomTypeId\": 1, \"mstRoomId\": 2, \"noOfAvailableRooms\": 2, \"basicTariff\": 2500, \"specialTariff\": 500, \"noOfRequiredRooms\": 1, \"noOfAdults\": 1, \"noOfChildren\": 2, \"amount\": 3500, \"mstEnquiryStatusId\": 1, \"mstHoldReasonId\": 0, \"holdFollowUpDate\": \"2025-07-11\", \"mstHoldReasonNotes\": \"Some note\", \"mstLostReasonId\": 0, \"lostReasonNotes\": \"Another note\" }]'
        };
        console.log(tableData);

        const response = await IUDAPI(data, "Enquiry/IUDEnquiry");

        if (flag == 1) {

          
          //if flag ==1 , add
          if (response.data.Table[0].Result === "S") {
            toast.success("Enquiry  Inserted Successfully", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Enquiry insert Failed", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        } else if (flag == 2) {
          //if flag ==2 , update

          if (response.data.Table[0].Result === "M") {
            toast.success("Enquiry modified successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Enquiry modification failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
      }

  } else {
    // Show errors or stop submission
    // alert("Please fill details in the table before submitting.");
     setIsOpen(true);
        setIsLoading(false);
        setSubmitBtnDisabled(false);
  }
    } else {
      const data = {
        // data to be send to api, if add/update

        txnEnquiryId: TxnEnquiryId ? TxnEnquiryId : 0,
        createdBy: createdBy,
        flag: flag,
      };

      const response = await IUDAPI(data, "Enquiry/IUDEnquiry");

      if (flag == 3) {
        //if flag ==3 , delete
        if (response.data.Table[0].Result === "D") {
          toast.success("Enquiry Data Deleted Successfully", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Failed to delete Enquiry", {
            duration: 3000,
            position: "top-center",
          });
        }
        setTimeout(cancel, 3000);
      }
    }

   // cancel();
  };

  const handleEdit = async (rowIndex) => {
    
    setRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setTxnEnquiryId(bindEnquiryData[rowIndex].TxnEnquiryId);
    setConfirmBookingFlag(2);
    const value = bindEnquiryData[rowIndex];
    setFormData({
      ...formData,

      enquiryid: bindEnquiryData[rowIndex].EnquiryNo,
      enquirydate: bindEnquiryData[rowIndex].EnquiryDate,
      enquirytype: bindEnquiryData[rowIndex].MstEnquiryTypeId,
      fname: bindEnquiryData[rowIndex].FirstName,
      lname: bindEnquiryData[rowIndex].LastName,
      number: bindEnquiryData[rowIndex].MobileNumber,
      area: bindEnquiryData[rowIndex].Area,
      fromdate: bindEnquiryData[rowIndex].BookingFrom.split("T")[0],
      todate: bindEnquiryData[rowIndex].BookingTo.split("T")[0],
      state: bindEnquiryData[rowIndex].MstStateId,
      country: bindEnquiryData[rowIndex].MstCountryId,

      pincode: bindEnquiryData[rowIndex].Pincode,
      city: bindEnquiryData[rowIndex].MstCityId,
      streetdoorno: bindEnquiryData[rowIndex].StreetDoorNo,

      idproof: bindEnquiryData[rowIndex].MstIdProofId,
      idvalue: bindEnquiryData[rowIndex].IdNumber,
      email:bindEnquiryData[rowIndex].Email,

      sourcetype: bindEnquiryData[rowIndex].MstSourceId,
      source: bindEnquiryData[rowIndex].Source,
      referralcontact: bindEnquiryData[rowIndex].ContactNumber,
      noofdays: bindEnquiryData[rowIndex].NoOfDays,
    });

    const TesttxnEnquiryId = bindEnquiryData[rowIndex].TxnEnquiryId;
    setChildId(TesttxnEnquiryId);

    // Step 1: Filter by TxnEnquiryId
    const filtered = Object.values(bindenquiryChildData).filter(
      (item) => item && String(item.TxnEnquiryId) === String(TesttxnEnquiryId)
    );

    // Step 2: Group by RoomTypeId (or RoomType if ID is not available)
    // const grouped = {};
    // filtered.forEach((item) => {
    //   const key = item.MstRoomTypeId || item.RoomType; // fallback to RoomType if ID missing
    //   if (!grouped[key]) {
    //     grouped[key] = item; // Take only the first entry for each room type
    //   }
    // });
    const grouped = {};

filtered.forEach((item) => {
  const key = item.MstRoomTypeId || item.RoomType;

  if (!grouped[key]) {
    grouped[key] = {
      ...item,
      NoOfRequiredRooms: 0, // reset and count manually
    };
  }

  grouped[key].NoOfRequiredRooms += 1; // each DB row = 1 room
});

    // Step 3: Prepare final data for table
    let roomDetailsData = Object.values(grouped).map((item) => ({
      RoomTypeId: item.MstRoomTypeId || "",
      RoomType: item.RoomType || "",
      AvailableRooms: item.NoOfAvailableRooms || "",
      AvailableRoomsId: "",
      AvailableRoomsName: "",
      Numberofrooms: item.NoOfRequiredRooms || "",
      numberofadults: parseInt(item.NoOfAdults || 0),
      numberofchildren: parseInt(item.NoOfChildren || 0),
      Tariff: item.BasicTariff || "",
      specialtariff: item.SpecialTariff || "",
      amount: item.SpecialTariff * item.NoOfRequiredRooms || "",
      Size: item.Size || "",
      MaxOccupancy: item.MaxOccupancy || "",
      Bedrooms: item.Bedrooms || "",
      Balcony: item.Balcony || "",
      LivingRoom: item.LivingRoom || "",
      SpaceDetails: item.SpaceDetails || "",
      AmenitiesDetails: item.AmenitiesDetails || "",
      Photo: item.Photo || "",
    }));

    // ✅ If no data found → add empty row
    if (roomDetailsData.length === 0) {
      roomDetailsData = [
        {
          RoomTypeId: "",
          RoomType: "",
          AvailableRooms: "",
          Numberofrooms: "",
          numberofadults: "",
          numberofchildren: "",
          Tariff: "",
          specialtariff: "",
          amount: "",
          Size: "",
          MaxOccupancy: "",
          Bedrooms: "",
          Balcony: "",
          LivingRoom: "",
          SpaceDetails: "",
          AmenitiesDetails: "",
          Photo: "",
        },
      ];
    }
    // Step 5: Add AvailableRoomsId and AvailableRooms to each row
    const fromDate = toYMD(value.BookFrom); // "2025-08-01"; // or use dynamic: toYMD(value.BookFrom)
    const toDate = toYMD(value.BookTo); //"2025-08-05"; // or use dynamic: toYMD(value.BookTo)

    for (let i = 0; i < roomDetailsData.length; i++) {
      const row = roomDetailsData[i];
      if (!row.RoomTypeId) continue;

      try {
        const postData = {
          mstRoomTypeId: row.RoomTypeId,
          fromDate: fromDate,
          toDate: toDate,
          mstClientId: clientId,
        };

        const response = await BindPostAPI(
          postData,
          "Enquiry/BindGetRoomDetails"
        );
        const apiRow = response?.data?.Table?.[0];

        if (apiRow) {
          row.AvailableRoomsId = apiRow.AvailableRoomsId ?? "";
          row.AvailableRooms = apiRow.AvailableRooms ?? null;
          row.AvailableRoomsName = apiRow.AvailableRoomsName ?? "";
        } else {
          //    row.AvailableRoomsId = "";
          row.AvailableRooms = null;
        }
      } catch (err) {
        console.error(`RoomTypeId ${row.RoomTypeId} failed:`, err);
        //   row.AvailableRoomsId = "";
        row.AvailableRooms = null;
      }
    }
    // Reset existing rows and set new
    handleDeleteRow(0);
    setTableData(roomDetailsData);
  };
  const handleBookingEdit = async (rowIndex, flag) => {
    const value = bindBookingData[rowIndex];
    const txnEnquiryId = value.TxnEnquiryId;
    setViewPopUp(true);
    const updatedValue = {
      ...value, // copy all existing fields
      TotalAmount: value.BookingTotalAmount,
      ReceivedAmount: value.BookingReceivedAmount,
      BalanceAmount: value.BookingBalanceAmount,
      PaymentType: value.BookingPaymentType,
      PaymentRefNumber: value.BookingPaymentReferenceNumber,
      ShowImage: value.BookingPaymentReference,
    };
    const drpdetailsData = [
      countrydropdown,
      statedropdown,
      referralsource,
      iddropdown,
      roomtype,
      paymentType,
      citydropdown,
    ];
    setConfirmRecord1(drpdetailsData);

    // Step 1: Filter child records for this enquiry
    const filtered = Object.values(bindenquiryChildData).filter(
      (item) => String(item.TxnEnquiryId) === String(txnEnquiryId)
    );

    // Step 2: Grouping to get unique RoomType
    const groupedTable = {};
    filtered.forEach((item) => {
      const key = item.MstRoomTypeId || item.RoomType;
      if (!groupedTable[key]) {
        groupedTable[key] = item;
      }
    });

    // Step 3: Create base roomTableDetailsData with everything from enquiry child
    const roomTableDetailsData = Object.values(groupedTable)
      // .filter((item) => item.BookingNoOfRequiredRooms > 0)
      .map((item) => ({
        RoomTypeId: item.MstRoomTypeId,
        RoomType: item.RoomType,
        RoomId: item.RoomId,
        AvailableRoomsId: "",
        AvailableRoomsId: "", // will be fetched
  AvailableRoomsName: "",
  
        SelectedRoomIds: item.SelectedRoomIds, // will be fetched
        selectedRooms: item.SelectedRoomIds,
        AvailableRooms: item.BookingNoOfAvailableRooms, // will be fetched
        Numberofrooms: item.BookingNoOfRequiredRooms,
        numberofadults: item.BookingNoOfAdults,
        numberofchildren: item.BookingNoOfChildren,
        Tariff: item.BookingBasicTariff,
        specialtariff: item.BookingSpecialTariff,
        amount: item.BookingAmount * item.BookingNoOfRequiredRooms,
        Photo: item.Photo,
        Size: item.Size,
        MaxOccupancy: item.MaxOccupancy,
        Bedrooms: item.Bedrooms,
        Balcony: item.Balcony,
        LivingRoom: item.LivingRoom,
        SpaceDetails: item.SpaceDetails,
        AmenitiesDetails: item.AmenitiesDetails,
      }));

    // Step 4: Show popup now, will fill data next
    //  handleDeleteRow(0);
    setConfirmRecord2([]);
    setConfirmRecord2(roomTableDetailsData); // temporary without availableRooms
    // setTableData(roomTableDetailsData); // temporary without availableRooms

    // Step 5: Add AvailableRoomsId and AvailableRooms to each row
    const fromDate = toYMD(value.BookFrom); // "2025-08-01"; // or use dynamic: toYMD(value.BookFrom)
    const toDate = toYMD(value.BookTo); //"2025-08-05"; // or use dynamic: toYMD(value.BookTo)

    for (let i = 0; i < roomTableDetailsData.length; i++) {
      const row = roomTableDetailsData[i];
      if (!row.RoomTypeId) continue;

      try {
        const postData = {
          mstRoomTypeId: row.RoomTypeId,
          fromDate: fromDate,
          toDate: toDate,
          mstClientId: clientId,
        };

        const response = await BindPostAPI(
          postData,
          "Enquiry/BindGetRoomDetails"
        );
        const apiRow = response?.data?.Table?.[0];

        if (apiRow) {
          row.AvailableRoomsId = apiRow.AvailableRoomsId ?? "";
          row.AvailableRooms = apiRow.AvailableRooms ?? null;
          row.AvailableRoomsName = apiRow.AvailableRoomsName ?? "";
        } else {
          //    row.AvailableRoomsId = "";
          row.AvailableRooms = null;
        }
      } catch (err) {
        console.error(`RoomTypeId ${row.RoomTypeId} failed:`, err);
        //   row.AvailableRoomsId = "";
        row.AvailableRooms = null;
      }
    }

    // Step 6: Push final tableData with AvailableRooms
    setTableData([...roomTableDetailsData]);

    setConfirmRecord(updatedValue);
    setpopUpBookOpen(true);
  };
  const appendToTableData = (newDataString) => {
    //
    const newDataArray = JSON.parse(newDataString);
    handleDeleteRow(0);
    setTableData([]);
    const formattedDataArray = newDataArray.map((data) => {
      return {
        RoomTypeId: data.MstRoomTypeId,
        AvailableRooms: data.NoOfAvailableRooms,
        Numberofrooms: data.NoOfRequiredRooms,
        numberofadults: data.NoOfAdults,
        numberofchildren: data.NoOfChildren,
        Tariff: data.BasicTariff,
        specialtariff: data.SpecialTariff,
        amount: data.Amount,

        Size: data.Size,
        MaxOccupancy: data.MaxOccupancy,
        Bedrooms: data.Bedrooms,
        RoomType: data.RoomType,
        Balcony: data.Balcony,
        LivingRoom: data.LivingRoom,
        SpaceDetails: data.SpaceDetails,
        AmenitiesDetails: data.AmenitiesDetails,
      };
    });

    setTableData((prevData) => [...prevData, ...formattedDataArray]);
  };
  const toYMD = (dateStr) => {
    // dateStr format: "DD-MM-YYYY"
    const [dd, mm, yyyy] = dateStr.split("-");
    return `${yyyy}-${mm}-${dd}`;
  };
  const onConfirmBooking = async (rowIndex, flag) => {
    setViewPopUp(false);
    const value = bindEnquiryData[rowIndex];
    const txnEnquiryId = value.TxnEnquiryId;

     // Update only required fields
    const updatedValue = {
        ...value, // keeps all existing fields unchanged

        // you can override anything you need
       
        BookingPersonFirstName: value.FirstName,
        BookingPersonLastName: value.LastName,
        BookingPersonMobileNumber: value.MobileNumber,
        BookingPersonMstCityId: value.MstCityId,
        BookingPersonMstStateId: value.MstStateId,
        BookingPersonMstCountryId: value.MstCountryId,
        BookingPersonStreetDoorNo: value.StreetDoorNo,
        BookingPersonArea: value.Area,
        BookingPersonPincode: value.Pincode,
        BookingContactNumber: value.ContactNumber,
    };
    setConfirmRecord(updatedValue);
debugger;
    const drpdetailsData = [
      countrydropdown,
      statedropdown,
      referralsource,
      iddropdown,
      roomtype,
      paymentType,
      citydropdown,
    ];
    setConfirmRecord1(drpdetailsData);

    // Step 1: Filter child records for this enquiry
    const filtered = Object.values(bindenquiryChildData).filter(
      (item) => String(item.TxnEnquiryId) === String(txnEnquiryId)
    );

    // Step 2: Grouping to get unique RoomType
    // const groupedTable = {};
    // filtered.forEach((item) => {
    //   const key = item.MstRoomTypeId || item.RoomType;
    //   if (!groupedTable[key]) {
    //     groupedTable[key] = item;
    //   }
    // });


    const grouped = {};

    filtered.forEach((item) => {
      const key = item.MstRoomTypeId || item.RoomType;
    
      if (!grouped[key]) {
        grouped[key] = {
          ...item,
          NoOfRequiredRooms: 0, // reset and count manually
        };
      }
    
      grouped[key].NoOfRequiredRooms += 1; // each DB row = 1 room
    });
    

    // Step 3: Create base roomTableDetailsData with everything from enquiry child
    const roomTableDetailsData = Object.values(grouped).map((item) => ({
      RoomTypeId: item.MstRoomTypeId,
      RoomType: item.RoomType,
      RoomId: item.RoomId,
      AvailableRoomsName: "",
      AvailableRoomsId: "", // will be fetched
      AvailableRooms: item.NoOfAvailableRooms, // will be fetched
      Numberofrooms: item.NoOfRequiredRooms,
      numberofadults: item.NoOfAdults,
      numberofchildren: item.NoOfChildren,
      Tariff: item.BasicTariff,
      specialtariff: item.SpecialTariff,
      amount: item.SpecialTariff* item.NoOfRequiredRooms,
      Photo: item.Photo,
      Size: item.Size,
      MaxOccupancy: item.MaxOccupancy,
      Bedrooms: item.Bedrooms,
      Balcony: item.Balcony,
      LivingRoom: item.LivingRoom,
      SpaceDetails: item.SpaceDetails,
      AmenitiesDetails: item.AmenitiesDetails,
    }));

    // Step 4: Show popup now, will fill data next
    handleDeleteRow(0);
    setConfirmRecord2(roomTableDetailsData); // temporary without availableRooms
    setpopUpBookOpen(true);

    // Step 5: Add AvailableRoomsId and AvailableRooms to each row
    const fromDate = toYMD(value.BookFrom); // "2025-08-01"; // or use dynamic: toYMD(value.BookFrom)
    const toDate = toYMD(value.BookTo); //"2025-08-05"; // or use dynamic: toYMD(value.BookTo)

    for (let i = 0; i < roomTableDetailsData.length; i++) {
      const row = roomTableDetailsData[i];
      if (!row.RoomTypeId) continue;

      try {
        const postData = {
          mstRoomTypeId: row.RoomTypeId,
          fromDate: fromDate,
          toDate: toDate,
          mstClientId: clientId,
        };

        const response = await BindPostAPI(
          postData,
          "Enquiry/BindGetRoomDetails"
        );
        const apiRow = response?.data?.Table?.[0];

        if (apiRow) {
          row.AvailableRoomsId = apiRow.AvailableRoomsId ?? "";
          row.AvailableRooms = apiRow.AvailableRooms ?? 0;
          row.AvailableRoomsName = apiRow.AvailableRoomsName ?? "";
        } else {
          row.AvailableRoomsId = "";
          row.AvailableRooms = 0;
        }
      } catch (err) {
        console.error(`RoomTypeId ${row.RoomTypeId} failed:`, err);
        row.AvailableRoomsId = "";
        row.AvailableRooms = 0;
      }
    }

    // Step 6: Push final tableData with AvailableRooms
    setTableData([...roomTableDetailsData]);
  };
  const onViewEnquiry = (rowIndex, flag) => {
    setViewPopUp(true);
     onCancelEnquiry(rowIndex, flag);
    // handleBookingEdit(rowIndex, flag);
  };
  const onCancelEnquiry = async (rowIndex, flag) => {
    const value = bindBookingData[rowIndex];

     // Update only required fields
    const updatedValue = {
        ...value, // keeps all existing fields unchanged

        // you can override anything you need
        BookingPersonNoOfDays: value.NoOfDays,
        BookingPersonFirstName: value.FirstName,
        BookingPersonLastName: value.LastName,
        BookingPersonMobileNumber: value.MobileNumber,
        BookingPersonMstCityId: value.MstCityId,
        BookingPersonMstStateId: value.MstStateId,
        BookingPersonMstCountryId: value.MstCountryId,
        BookingPersonStreetDoorNo: value.StreetDoorNo,
        BookingPersonArea: value.Area,
        BookingPersonPincode: value.Pincode,
        BookingContactNumber: value.ContactNumber,
    };
    debugger;
    const txnEnquiryId = value.TxnEnquiryId;
    const drpdetailsData = [
      countrydropdown,
      statedropdown,
      referralsource,
      iddropdown,
      roomtype,
      paymentType,
      citydropdown,
    ];
    setConfirmRecord1(drpdetailsData);

    // Step 1: Filter child records for this enquiry
    const filtered = Object.values(bindenquiryChildData).filter(
      (item) => String(item.TxnEnquiryId) === String(txnEnquiryId)
    );

    // Step 2: Grouping to get unique RoomType
    // const groupedTable = {};
    // filtered.forEach((item) => {
    //   const key = item.MstRoomTypeId || item.RoomType;
    //   if (!groupedTable[key]) {
    //     groupedTable[key] = item;
    //   }
    // });

    const grouped = {};

    filtered.forEach((item) => {
      const key = item.MstRoomTypeId || item.RoomType;
    
      if (!grouped[key]) {
        grouped[key] = {
          ...item,
          NoOfRequiredRooms: 0, // reset and count manually
        };
      }
    
      grouped[key].NoOfRequiredRooms += 1; // each DB row = 1 room
    });
    
    
    // Step 3: Create base roomTableDetailsData with everything from enquiry child
    const roomTableDetailsData = Object.values(grouped)
      .filter((item) => item.BookingNoOfRequiredRooms > 0)
      .map((item) => ({
        RoomTypeId: item.MstRoomTypeId,
        RoomType: item.RoomType,
        RoomId: item.RoomId,
        // AvailableRoomsName:"",
        AvailableRoomsName: item.SelectedRooms || item.SelectedRoomNames || "",
        AvailableRoomsId: item.SelectedRoomIds, // will be fetched
        AvailableRooms: item.BookingNoOfAvailableRooms, // will be fetched
        SelectedRoomIds: item.SelectedRoomIds, // Add this line
        selectedRooms: item.SelectedRoomIds, 
        Numberofrooms: item.BookingNoOfRequiredRooms,
        numberofadults: item.BookingNoOfAdults,
        numberofchildren: item.BookingNoOfChildren,
        Tariff: item.BookingBasicTariff,
        specialtariff: item.BookingSpecialTariff,
        amount: item.BookingAmount * item.BookingNoOfRequiredRooms,
        Photo: item.Photo,
        Size: item.Size,
        MaxOccupancy: item.MaxOccupancy,
        Bedrooms: item.Bedrooms,
        Balcony: item.Balcony,
        LivingRoom: item.LivingRoom,
        SpaceDetails: item.SpaceDetails,
        AmenitiesDetails: item.AmenitiesDetails,
      }));

    // Step 4: Show popup now, will fill data next
    //  handleDeleteRow(0);
    setConfirmRecord2([]);
    setConfirmRecord2(roomTableDetailsData); // temporary without availableRooms
    // setTableData(roomTableDetailsData); // temporary without availableRooms

    // Step 5: Add AvailableRoomsId and AvailableRooms to each row
    const fromDate = toYMD(value.BookFrom); // "2025-08-01"; // or use dynamic: toYMD(value.BookFrom)
    const toDate = toYMD(value.BookTo); //"2025-08-05"; // or use dynamic: toYMD(value.BookTo)

    for (let i = 0; i < roomTableDetailsData.length; i++) {
      const row = roomTableDetailsData[i];
      if (!row.RoomTypeId) continue;

      try {
        const postData = {
          mstRoomTypeId: row.RoomTypeId,
          fromDate: fromDate,
          toDate: toDate,
          mstClientId: clientId,
        };

        const response = await BindPostAPI(
          postData,
          "Enquiry/BindGetRoomDetails"
        );
        const apiRow = response?.data?.Table?.[0];

        if (apiRow) {
           row.AvailableRoomsId = apiRow.AvailableRoomsId ?? "";
          row.AvailableRooms = apiRow.AvailableRooms ?? null;
          row.AvailableRoomsName = apiRow.AvailableRoomsName ?? "";
        } else {
          //    row.AvailableRoomsId = "";
          row.AvailableRooms = null;
        }
      } catch (err) {
        console.error(`RoomTypeId ${row.RoomTypeId} failed:`, err);
        //   row.AvailableRoomsId = "";
        row.AvailableRooms = 0;
      }
    }

    // Step 6: Push final tableData with AvailableRooms
    setTableData([...roomTableDetailsData]);

    setConfirmRecord(updatedValue);
    setpopUpCancelOpen(true);
  };
  const onHoldEnquiry = (rowIndex, flag) => {
    if (flag === 1) {
      console.log("val:", rowIndex);
      setRowIndex(rowIndex);
      setpopUpHoldOpen(true);
      //onSave()
      handleSubmit();

      const holdData = {
        fname: formData.fname,
        lname: formData.lname,
        number: formData.number,
        fromdate: formData.fromdate,
        todate: formData.todate,
        enquiryid: formData.enquiryid,
        enquirydate: formData.enquirydate,
      };
      setHoldRecord(holdData);
    } else {
      setpopUpHoldOpen(true);
      const holdDatapop = {
        fname: bindEnquiryData[rowIndex].FirstName,
        lname: bindEnquiryData[rowIndex].LastName,
        number: bindEnquiryData[rowIndex].MobileNumber,
        fromdate: bindEnquiryData[rowIndex].BookingFrom.split("T")[0],
        todate: bindEnquiryData[rowIndex].BookingTo.split("T")[0],
        enquiryid: bindEnquiryData[rowIndex].EnquiryNo,
        enquirydate: bindEnquiryData[rowIndex].EnquiryDate.split("T")[0],
      };

      setHoldRecord(holdDatapop);
    }
  };
  //const

  const [lostTableData, setLostTableData] = useState([]);

//   const onLostEnquiry = async (rowIndex, flag) => {
    
//     //
//     setpopUpLostOpen(true); // move this AFTER data is set
//     if (flag === 1) {
    
//       const isValid = validateForm("save"); // Validate only save fields
    
//     if (flag == 1 || flag == 2) {
//       if (!isValid) {
//         setIsOpen(true);
//         setIsLoading(false);
//         setSubmitBtnDisabled(false);
//       }
//       if (validateTableData()) {
//     // Proceed to submit
  
//       if (isValid) {
//         setIsOpen(false);
//         setIsLoading(true);
//         setSubmitBtnDisabled(true);
//         const filteredTableData = tableData.filter(
//           (row) => row.RoomTypeId && row.RoomTypeId !== ""
//         );
//         const data = {
//           txnEnquiryId: TxnEnquiryId ? TxnEnquiryId : 0,
//           enquiryNo: "ENQ" || bindEnquiryData[rowIndex].TxnEnquiryId,
//           mstClientId: clientId,
//           enquiryDate: formData.enquirydate,
//           mstEnquiryTypeId: formData.enquirytype || 0,
//           bookingFrom: formData.fromdate,
//           bookingTo: formData.todate,
//           noOfDays: formData.noofdays || 0,
//           //done
//           firstName: formData.fname || "",
//           lastName: formData.lname || "",
//           mobileNumber: formData.number || "",
//           //done
//           mstCountryId: formData.country || 0,
//           mstStateId: parseInt(formData.state)|| null,
//           city: formData.city || 0,

//           stateName:formData.statename || "",
//           cityName:formData.cityname || "",
//           streetDoorNo: formData.streetdoorno || "",
//           area: formData.area || "",
//           pincode: formData.pincode || "",
//           mstSourceTypeId: formData.sourcetype || 0,
//           contactNumber: formData.referralcontact || "",
//           mstIdProofId: formData.idproof || 0,

//           idNumber: formData.idvalue || "",
//           source: formData.source || "",

//           //belowdone
//           amount: formData.amountpaid || 0,
//           mstEnquiryStatusId: "1" || 0,
//           createdBy: createdBy,
//           flag: flag,
//           enquiryChild: JSON.stringify(filteredTableData),
//           //enquiryChild: '[{ \"mstRoomTypeId\": 1, \"mstRoomId\": 2, \"noOfAvailableRooms\": 2, \"basicTariff\": 2500, \"specialTariff\": 500, \"noOfRequiredRooms\": 1, \"noOfAdults\": 1, \"noOfChildren\": 2, \"amount\": 3500, \"mstEnquiryStatusId\": 1, \"mstHoldReasonId\": 0, \"holdFollowUpDate\": \"2025-07-11\", \"mstHoldReasonNotes\": \"Some note\", \"mstLostReasonId\": 0, \"lostReasonNotes\": \"Another note\" }]'
//         };
//         console.log(tableData);

//         const response = await IUDAPI(data, "Enquiry/IUDEnquiry");
//         console.log(data);
//         console.log("formData:", formData);

//         if (flag == 1) {
//           //if flag ==1 , add
//           if (response.data.Table[0].Result === "S") {
            
//             const selectedRow = response.data.Table1[0];
//       const lostDataPop = {
//         fname: selectedRow.FirstName,
//         lname: selectedRow.LastName,
//         number: selectedRow.MobileNumber,
//         fromdate: selectedRow.BookingFrom.split("T")[0],
//         todate: selectedRow.BookingTo.split("T")[0],
//         enquiryid: selectedRow.EnquiryNo,
//       };
//       setLostRecord(lostDataPop);

//       const TesttxnEnquiryId = response.data.Table1[0].TxnEnquiryId;
//       setChildId(TesttxnEnquiryId);

//       // Step 1: Filter data for this enquiry
//       // const filtered = bindenquiryChildData.filter(
//       //   (item) => item && String(item.TxnEnquiryId) === String(TesttxnEnquiryId)
//       // );
//       const filtered  =response.data.Table2
//       // Step 2: Group by RoomTypeId or RoomType
//       const grouped = {};
//       filtered.forEach((item) => {
//         const key = item.MstRoomTypeId || item.RoomType;

//         if (!grouped[key]) {
//           // First room of this type
//           grouped[key] = {
//             ...item,
//             NoOfRequiredRooms: Number(item.NoOfRequiredRooms || 0),
//           };
//         } else {
//           // Add to existing group
//           grouped[key].NoOfRequiredRooms += Number(item.NoOfRequiredRooms || 0);
//         }
//       });

//       // Step 3: Final data for table
//       const roomDetailsData = Object.values(grouped).map((item) => ({
//         TxnEnquiryId: item.TxnEnquiryId,
//         RoomTypeId: item.MstRoomTypeId,
//         RoomType: item.RoomType,
//         Photo: item.Photo
//           ? item.Photo.startsWith("http") || item.Photo.startsWith("data:")
//             ? item.Photo
//             : `data:image/jpeg;base64,${item.Photo}`
//           : "",
//         Size: item.Size,
//         MaxOccupancy: item.MaxOccupancy,
//         SpaceDetails: item.SpaceDetails,
//         AmenitiesDetails: item.AmenitiesDetails,
//         NoOfRequiredRooms: item.NoOfRequiredRooms, // ✅ Already summed!
//         AvailableRoomsName: item.AvailableRoomsName || "",
//       }));

//       // Step 4: Push to table
//       handleDeleteRow(0);
//       setLostTableData(roomDetailsData);

//           } else {
//             toast.error("Enquiry insert Failed", {
//               duration: 3000,
//               position: "top-center",
//             });
//             setTimeout(cancel, 3000);
//           }
//         } else if (flag == 2) {
//           //if flag ==2 , update

//           if (response.data.Table[0].Result === "M") {
           
//             const selectedRow = bindEnquiryData[rowIndex];
//       const lostDataPop = {
//         fname: selectedRow.FirstName,
//         lname: selectedRow.LastName,
//         number: selectedRow.MobileNumber,
//         fromdate: selectedRow.BookingFrom.split("T")[0],
//         todate: selectedRow.BookingTo.split("T")[0],
//         enquiryid: selectedRow.EnquiryNo,
//       };
//       setLostRecord(lostDataPop);

//       const TesttxnEnquiryId = bindEnquiryData[rowIndex].TxnEnquiryId;
//       setChildId(TesttxnEnquiryId);

//       // Step 1: Filter data for this enquiry
//       const filtered = bindenquiryChildData.filter(
//         (item) => item && String(item.TxnEnquiryId) === String(TesttxnEnquiryId)
//       );

//       // Step 2: Group by RoomTypeId or RoomType
//       const grouped = {};
//       filtered.forEach((item) => {
//         const key = item.MstRoomTypeId || item.RoomType;

//         if (!grouped[key]) {
//           // First room of this type
//           grouped[key] = {
//             ...item,
//             NoOfRequiredRooms: Number(item.NoOfRequiredRooms || 0),
//           };
//         } else {
//           // Add to existing group
//           grouped[key].NoOfRequiredRooms += Number(item.NoOfRequiredRooms || 0);
//         }
//       });

//       // Step 3: Final data for table
//       const roomDetailsData = Object.values(grouped).map((item) => ({
//         TxnEnquiryId: item.TxnEnquiryId,
//         RoomTypeId: item.MstRoomTypeId,
//         RoomType: item.RoomType,
//         Photo: item.Photo
//           ? item.Photo.startsWith("http") || item.Photo.startsWith("data:")
//             ? item.Photo
//             : `data:image/jpeg;base64,${item.Photo}`
//           : "",
//         Size: item.Size,
//         MaxOccupancy: item.MaxOccupancy,
//         SpaceDetails: item.SpaceDetails,
//         AmenitiesDetails: item.AmenitiesDetails,
//         NoOfRequiredRooms: item.NoOfRequiredRooms, // ✅ Already summed!
//         AvailableRoomsName: item.AvailableRoomsName || "",
//       }));

//       // Step 4: Push to table
//       handleDeleteRow(0);
//       setLostTableData(roomDetailsData);
      

//           } else {
//             toast.error("Enquiry modification failed 👎", {
//               duration: 3000,
//               position: "top-center",
//             });
//             setTimeout(cancel, 3000);
//           }
//         }
        
//       } else {
//         setSubmitBtnDisabled(false);
//       }

//     }

//     setIsLoading(false)
//     }
       


//     //   // Flag 1: form-based data
//     //   setRowIndex(rowIndex);
//     //   const lostData = {
//     //     fname: formData.fname,
//     //     lname: formData.lname,
//     //     number: formData.number,
//     //     fromdate: formData.fromdate,
//     //     todate: formData.todate,
//     //     enquiryid: formData.enquiryid,
//     //   };
//     //   setLostRecord(lostData);
//     //   setpopUpLostOpen(true);
//     //  // handleSubmit();

// // setpopUpLostOpen(false);
// // setVisibleTable(true)
      
    

      

      
     
//     } else {
//       // Flag not 1: table row based
//       const selectedRow = bindEnquiryData[rowIndex];
//       const lostDataPop = {
//         fname: selectedRow.FirstName,
//         lname: selectedRow.LastName,
//         number: selectedRow.MobileNumber,
//         fromdate: selectedRow.BookingFrom.split("T")[0],
//         todate: selectedRow.BookingTo.split("T")[0],
//         enquiryid: selectedRow.EnquiryNo,
//       };
//       setLostRecord(lostDataPop);

//       const TesttxnEnquiryId = bindEnquiryData[rowIndex].TxnEnquiryId;
//       setChildId(TesttxnEnquiryId);

//       // Step 1: Filter data for this enquiry
//       const filtered = bindenquiryChildData.filter(
//         (item) => item && String(item.TxnEnquiryId) === String(TesttxnEnquiryId)
//       );

//       // Step 2: Group by RoomTypeId or RoomType
//       const grouped = {};
//       filtered.forEach((item) => {
//         const key = item.MstRoomTypeId || item.RoomType;

//         if (!grouped[key]) {
//           // First room of this type
//           grouped[key] = {
//             ...item,
//             NoOfRequiredRooms: Number(item.NoOfRequiredRooms || 0),
//           };
//         } else {
//           // Add to existing group
//           grouped[key].NoOfRequiredRooms += Number(item.NoOfRequiredRooms || 0);
//         }
//       });

//       // Step 3: Final data for table
//       const roomDetailsData = Object.values(grouped).map((item) => ({
//         TxnEnquiryId: item.TxnEnquiryId,
//         RoomTypeId: item.MstRoomTypeId,
//         RoomType: item.RoomType,
//         Photo: item.Photo
//           ? item.Photo.startsWith("http") || item.Photo.startsWith("data:")
//             ? item.Photo
//             : `data:image/jpeg;base64,${item.Photo}`
//           : "",
//         Size: item.Size,
//         MaxOccupancy: item.MaxOccupancy,
//         SpaceDetails: item.SpaceDetails,
//         AmenitiesDetails: item.AmenitiesDetails,
//         NoOfRequiredRooms: item.NoOfRequiredRooms, // ✅ Already summed!
//         AvailableRoomsName: item.AvailableRoomsName || ""
//       }));

//       // Step 4: Push to table
//       handleDeleteRow(0);
//       setLostTableData(roomDetailsData);
//     }
//   };
const onLostEnquiry = async (rowIndex, flag) => {
  setpopUpLostOpen(false); // make sure it's closed first
  setLostTableData([]);    // clear previous data
  setLostRecord(null);

  let selectedRow;
  let txnEnquiryId;

  if (flag === 1) {
    // From form (new enquiry)
    if (!validateForm("save") || !validateTableData()) {
      setIsOpen(true);
      return;
    }

    setIsLoading(true);

    const filteredTableData = tableData.filter(
      (row) => row.RoomTypeId && row.RoomTypeId !== ""
    );

    const data = {
      txnEnquiryId: TxnEnquiryId || 0,
      enquiryNo: "ENQ",
      mstClientId: clientId,
      enquiryDate: formData.enquirydate,
      mstEnquiryTypeId: formData.enquirytype || 0,
      bookingFrom: formData.fromdate,
      bookingTo: formData.todate,
      noOfDays: formData.noofdays || 0,
      firstName: formData.fname || "",
      lastName: formData.lname || "",
      mobileNumber: formData.number || "",
      mstCountryId: formData.country || 0,
      mstStateId: parseInt(formData.state) || 0,
      city: formData.city || 0,
      stateName: formData.statename || "",
      cityName: formData.cityname || "",
      streetDoorNo: formData.streetdoorno || "",
      area: formData.area || "",
      pincode: formData.pincode || "",
      mstSourceTypeId: formData.sourcetype || 0,
      contactNumber: formData.referralcontact || "",
      mstIdProofId: formData.idproof || 0,
      idNumber: formData.idvalue || "",
      source: formData.source || "",
      amount: formData.amountpaid || 0,
      mstEnquiryStatusId: "1",
      createdBy: createdBy,
      flag: 1,
      enquiryChild: JSON.stringify(filteredTableData),
    };

    try {
      const response = await IUDAPI(data, "Enquiry/IUDEnquiry");

      if (response?.data?.Table?.[0]?.Result === "S") {
        selectedRow = response.data.Table1[0];
        txnEnquiryId = response.data.Table1[0].TxnEnquiryId;

        // Prepare lost popup data
        const lostDataPop = {
          fname: selectedRow.FirstName,
          lname: selectedRow.LastName,
          number: selectedRow.MobileNumber,
          fromdate: selectedRow.BookingFrom?.split("T")[0] || "",
          todate: selectedRow.BookingTo?.split("T")[0] || "",
          enquiryid: selectedRow.EnquiryNo,
        };
        setLostRecord(lostDataPop);

        // Use fresh child data from response
        const childData = response.data.Table2 || [];

        const grouped = {};
        childData.forEach((item) => {
          const key = item.MstRoomTypeId || item.RoomType;
          if (!grouped[key]) {
            grouped[key] = { ...item, NoOfRequiredRooms: Number(item.NoOfRequiredRooms || 0) };
          } else {
            grouped[key].NoOfRequiredRooms += Number(item.NoOfRequiredRooms || 0);
          }
        });

        const roomDetailsData = Object.values(grouped).map((item) => ({
          TxnEnquiryId: item.TxnEnquiryId,
          RoomTypeId: item.MstRoomTypeId,
          RoomType: item.RoomType,
          Photo: item.Photo
            ? item.Photo.startsWith("http") || item.Photo.startsWith("data:")
              ? item.Photo
              : `data:image/jpeg;base64,${item.Photo}`
            : "",
          Size: item.Size || "",
          MaxOccupancy: item.MaxOccupancy || "",
          SpaceDetails: item.SpaceDetails || "",
          AmenitiesDetails: item.AmenitiesDetails || "",
          NoOfRequiredRooms: item.NoOfRequiredRooms,
          AvailableRoomsName: item.AvailableRoomsName || "",
        }));

        setLostTableData(roomDetailsData);
        setChildId(txnEnquiryId);

        // Now open popup **after** data is set
        setpopUpLostOpen(true);
      } else {
        toast.error("Failed to create enquiry");
      }
    } catch (err) {
      console.error("Error saving enquiry for lost:", err);
      toast.error("Error while saving enquiry");
    } finally {
      setIsLoading(false);
    }
  } else {
    // From table row
    selectedRow = bindEnquiryData[rowIndex];
    txnEnquiryId = selectedRow.TxnEnquiryId;

    const lostDataPop = {
      fname: selectedRow.FirstName,
      lname: selectedRow.LastName,
      number: selectedRow.MobileNumber,
      fromdate: selectedRow.BookingFrom?.split("T")[0] || "",
      todate: selectedRow.BookingTo?.split("T")[0] || "",
      enquiryid: selectedRow.EnquiryNo,
    };
    setLostRecord(lostDataPop);
    setChildId(txnEnquiryId);

    // Get child data
    const filtered = bindenquiryChildData.filter(
      (item) => String(item.TxnEnquiryId) === String(txnEnquiryId)
    );

    const grouped = {};
    filtered.forEach((item) => {
      const key = item.MstRoomTypeId || item.RoomType;
      if (!grouped[key]) {
        grouped[key] = { ...item, NoOfRequiredRooms: Number(item.NoOfRequiredRooms || 0) };
      } else {
        grouped[key].NoOfRequiredRooms += Number(item.NoOfRequiredRooms || 0);
      }
    });

    const roomDetailsData = Object.values(grouped).map((item) => ({
      TxnEnquiryId: item.TxnEnquiryId,
      RoomTypeId: item.MstRoomTypeId,
      RoomType: item.RoomType,
      Photo: item.Photo
        ? item.Photo.startsWith("http") || item.Photo.startsWith("data:")
          ? item.Photo
          : `data:image/jpeg;base64,${item.Photo}`
        : "",
      Size: item.Size || "",
      MaxOccupancy: item.MaxOccupancy || "",
      SpaceDetails: item.SpaceDetails || "",
      AmenitiesDetails: item.AmenitiesDetails || "",
      NoOfRequiredRooms: item.NoOfRequiredRooms,
      AvailableRoomsName: item.AvailableRoomsName || "",
    }));

    setLostTableData(roomDetailsData);

    // Open popup after setting data
    setpopUpLostOpen(true);
  }
};
  const handleState = async (rowIndex, flag) => {
    
    setRowIndex(rowIndex);
    setTxnEnquiryId(bindEnquiryData[rowIndex].TxnEnquiryId);
    setpopUpOpen(true);
    // setFormData({
    //   ...formData,
    //   fromdate: bindEnquiryData[rowIndex].BookingFrom.split("T")[0],
    //   todate: bindEnquiryData[rowIndex].BookingTo.split("T")[0],
    // });
    // villaselectchange(bindEnquiryData[rowIndex].MstRoomTypeIds,rowIndex)

    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }

      // Instead of creating dropdownvalues with single items, pass all dropdown arrays
  const allDropdownData = [
    enquirytypedropdown,  // Full enquiry types array
    countrydropdown,      // Full countries array
    statedropdown,        // Full states array
    citydropdown,         // Full cities array
    referralsource,       // Full source types array
    iddropdown,           // Full ID proofs array
  ];
  
  setPopUpData(allDropdownData);

    setSelectedRecord(bindEnquiryData[rowIndex]);
  const value = bindEnquiryData[rowIndex];
    const TesttxnEnquiryId = bindEnquiryData[rowIndex].TxnEnquiryId;
    setChildId(TesttxnEnquiryId);

     // Step 1: Filter by TxnEnquiryId
    const filtered = Object.values(bindenquiryChildData).filter(
      (item) => item && String(item.TxnEnquiryId) === String(TesttxnEnquiryId)
    );

    // Step 2: Group by RoomTypeId (or RoomType if ID is not available)
    // const grouped = {};
    // filtered.forEach((item) => {
    //   const key = item.MstRoomTypeId || item.RoomType; // fallback to RoomType if ID missing
    //   if (!grouped[key]) {
    //     grouped[key] = item; // Take only the first entry for each room type
    //   }
    // });
    const grouped = {};

    filtered.forEach((item) => {
      const key = item.MstRoomTypeId || item.RoomType;
    
      if (!grouped[key]) {
        grouped[key] = {
          ...item,
          NoOfRequiredRooms: 0, // reset and count manually
        };
      }
    
      grouped[key].NoOfRequiredRooms += 1; // each DB row = 1 room
    });

    // Step 3: Prepare final data for table
    let roomDetailsData = Object.values(grouped).map((item) => ({
      RoomTypeId: item.MstRoomTypeId || "",
      RoomType: item.RoomType || "",
      AvailableRooms: item.NoOfAvailableRooms || "",
      AvailableRoomsId: "",
      AvailableRoomsName: "",
      Numberofrooms: item.NoOfRequiredRooms || "",
      numberofadults: parseInt(item.NoOfAdults || 0),
      numberofchildren: parseInt(item.NoOfChildren || 0),
      Tariff: item.BasicTariff || "",
      specialtariff: item.SpecialTariff || "",
      amount: item.SpecialTariff*item.NoOfRequiredRooms || "",
      Size: item.Size || "",
      MaxOccupancy: item.MaxOccupancy || "",
      Bedrooms: item.Bedrooms || "",
      Balcony: item.Balcony || "",
      LivingRoom: item.LivingRoom || "",
      SpaceDetails: item.SpaceDetails || "",
      AmenitiesDetails: item.AmenitiesDetails || "",
      Photo: item.Photo || "",
    }));

    // ✅ If no data found → add empty row
    if (roomDetailsData.length === 0) {
      roomDetailsData = [
        {
          RoomTypeId: "",
          RoomType: "",
          AvailableRooms: "",
          Numberofrooms: "",
          numberofadults: "",
          numberofchildren: "",
          Tariff: "",
          specialtariff: "",
          amount: "",
          Size: "",
          MaxOccupancy: "",
          Bedrooms: "",
          Balcony: "",
          LivingRoom: "",
          SpaceDetails: "",
          AmenitiesDetails: "",
          Photo: "",
        },
      ];
    }
    // Step 5: Add AvailableRoomsId and AvailableRooms to each row
    const fromDate = toYMD(value.BookFrom); // "2025-08-01"; // or use dynamic: toYMD(value.BookFrom)
    const toDate = toYMD(value.BookTo); //"2025-08-05"; // or use dynamic: toYMD(value.BookTo)

    for (let i = 0; i < roomDetailsData.length; i++) {
      const row = roomDetailsData[i];
      if (!row.RoomTypeId) continue;

      try {
        const postData = {
          mstRoomTypeId: row.RoomTypeId,
          fromDate: fromDate,
          toDate: toDate,
          mstClientId: clientId,
        };

        const response = await BindPostAPI(
          postData,
          "Enquiry/BindGetRoomDetails"
        );
        const apiRow = response?.data?.Table?.[0];

        if (apiRow) {
          row.AvailableRoomsId = apiRow.AvailableRoomsId ?? "";
          row.AvailableRooms = apiRow.AvailableRooms ?? null;
          row.AvailableRoomsName = apiRow.AvailableRoomsName ?? ""; 
        } else {
          row.AvailableRoomsId = "";
          row.AvailableRooms = null;
          row.AvailableRoomsName = ""; 
        }
      } catch (err) {
        console.error(`RoomTypeId ${row.RoomTypeId} failed:`, err);
        //   row.AvailableRoomsId = "";
        row.AvailableRooms = null;
      }
    }
    // Reset existing rows and set new
    handleDeleteRow(0);
    setTableData(roomDetailsData);
  };

  const handleOptions = (value) => {
    if (value == 1) {
      //onSave();
      handleSubmit();
      setpopUpBookOpen(true);
      setOnBook(true);
      setHold(false);
      setLost(false);
    } else if (value == 2) {
      handleSubmit();
      //onSave();
      setpopUpHoldOpen(true);
      setOnBook(false);
      setHold(true);
      setLost(false);
    } else {
      //onSave();
      handleSubmit();
      setpopUpLostOpen(true);
      setOnBook(false);
      setHold(false);
      setLost(true);
    }
  };

  const handleAddRow = () => {
    if (tableData.length > 3) return;

    const newRow = {
      basictariff: "",
    };

    setTableData((prev) => [...prev, newRow]);
  };
  const emptyRow = {
    RoomTypeId: "",
    AvailableRooms: "",
    Tariff: "",
    specialtariff: "",
    Numberofrooms: "",
    numberofadults: "",
    numberofchildren: "",
    amount: "",
  };

  // const handleDeleteRow = (index) => {
  //   setTableData((prev) => {
  //     if (index === 0) {
  //       const updated = [...prev];
  //       updated[0] = { ...emptyRow }; // reset first row
  //       return updated;
  //     } else {
  //       return prev.filter((_, i) => i !== index);
  //     }
  //   });
  // };

  const handleDeleteRow = (index) => {
    setTableData((prev) => {
      // If this is the last row and we're deleting it, reset to empty row
      if (prev.length === 1 && index === 0) {
        return [{ ...emptyRow }];
      }
      
      // If it's the first row (index 0) and there are multiple rows, just reset that row
      if (index === 0 && prev.length > 1) {
        const updated = [...prev];
        updated[0] = { ...emptyRow };
        return updated;
      }
      
      // Otherwise filter out the row
      return prev.filter((_, i) => i !== index);
    });
    
    // Clear any error messages related to this row
    if (tableErrorMessages.length > 0) {
      const filteredMessages = tableErrorMessages.filter(
        msg => !msg.includes(`Row ${index + 1}:`)
      );
      setTableErrorMessages(filteredMessages);
    }
    
    // Clear errors for this row
    if (tableErrors.length > 0) {
      const updatedErrors = [...tableErrors];
      delete updatedErrors[index];
      setTableErrors(updatedErrors.filter(Boolean));
    }
  };

  const handleInputChange = (event, index) => {
    const { name, value } = event.target;
    const updatedFields = [...tableData];
    updatedFields[index][name] = value;
    setTableData(updatedFields);
  };

  const [submitDetails, setSubmitDetails] = useState([]);

  const [getStateData, setGetStateData] = useState([]);
  const [getCityData, setGetCityData] = useState([]);

  const [bindStateDown1, setBindStateDown1] = useState([]);
  const [bindCityDown1, setBindCityDown1] = useState([]);

  useEffect(() => {
    BindGetEnquiryValues();
  }, []);

  const BindGetEnquiryValues = async () => {
    const data = {
      mstClientId: clientId,
    };

    console.log(data, "enquiry login No");
    //
    //
    const response = await BindPostAPI(data, "Enquiry/BindGetEnquiryValues");
    console.log("enquirydropdown:", response);
    if (response && response.data) {
      const enquiryTypeId = response?.data?.Table1?.map((item) => ({
        value: item.MstEnquiryTypeId,
        label: item.EnquiryType,
      }));

      setenquirydropdown(enquiryTypeId);

      const countryId = response?.data?.Table2?.map((item) => ({
        value: item.MstCountryId,
        label: item.CountryName,
      }));

      setCountrydropdown(countryId);

      const stateId = response?.data?.Table3?.map((item) => ({
        value: item.MstStateId,
        label: item.State,
        MstCountryId: item.MstCountryId
      }));

      setStatedropdown(stateId);
      console.log("stateId",stateId)
      setGetStateData(response.data.Table3);

      const cityId = response?.data?.Table4?.map((item) => ({
        value: item.MstCityId,
        label: item.City,
        MstStateId:item.MstStateId
      }));

      setcitydropdown(cityId);
      setGetCityData(response.data.Table4);

      const idProofId = response?.data?.Table5?.map((item) => ({
        value: item.MstIdProofId,
        label: item.IdProof,
      }));

      setiddropdown(idProofId);

      const referralsourceid = response?.data?.Table6?.map((item) => ({
        value: item.MstReferralSourceId,
        label: item.ReferralSource,
      }));
      setreferralsource(referralsourceid);

      const RoomTypeid = response?.data?.Table7?.map((item) => ({
        value: item.MstRoomTypeId,
        label: item.RoomType,
      }));
      //setTableData(RoomTypeid)
      setroomtype(RoomTypeid);
      console.log("RoomTypeid:", RoomTypeid);
      const PaymentTypeId = response?.data?.Table10?.map((item) => ({
        value: item.MstPaymentTypeId,
        label: item.PaymentTypeId,
      }));
      setPaymentType(PaymentTypeId);
    } else {
      setBindEnquiryData([]);
    }
  };

  useEffect(() => {
    // Find the selected state in getCityDatas

//     const countrySelectedValue = getStateData.find(
//       (item) => item.MstCountryId == formData.country
//     );
//     if (countrySelectedValue) {
//       const stateLabels = getStateData
//         .filter(
//           (item) => item.MstCountryId === countrySelectedValue.MstCountryId
//         )
//         .map((item) => ({ MstStateId: item.MstStateId, State: item.State }));

//       const stateSelected = stateLabels.map((LC) => ({
//         value: LC.MstStateId,
//         label: LC.State,
//       }));

//       stateSelected.push({
//   value: 0,     // ID for "Others" option
//   label: 'Others',  // Label for "Others"
// });
// //console.log(stateSelected,"Other selelcted")
//       setBindStateDown1(stateSelected);
//     } else {
//     }

//     const stateSelectedValue = getCityData.find(
//       (item) => item.MstStateId == formData.state // Replace with the desired MstStateId
//     );

//     if (stateSelectedValue) {
//       const cityLabels = getCityData
//         .filter((item) => item.MstStateId === stateSelectedValue.MstStateId)
//         .map((item) => ({
//           MstCityId: item.MstCityId,
//           City: item.City,
//         }));

//       const citySelected = cityLabels.map((LC) => ({
//         value: LC.MstCityId, // Replace with the appropriate value
//         label: LC.City,
//       }));
//       citySelected.push({
//   value: 0,     // ID for "Others" option
//   label: 'Others',  // Label for "Others"
// });

//       setBindCityDown1(citySelected);
//     } else {
//     }
//   }, [
//     formData.country ? formData.country : null,
//     formData.state ? formData.state : null,
//   ]);

if (formData.country) {

  const stateSelected = getStateData
    .filter(item => item.MstCountryId == formData.country)
    .map(item => ({
      value: item.MstStateId,
      label: item.State
    }));

  stateSelected.push({
    value: 0,
    label: "Others"
  });

  setBindStateDown1(stateSelected);

} else {

  setBindStateDown1([]);

}


// ✅ Filter City based on selected State
if (formData.state) {

  const citySelected = getCityData
    .filter(item => item.MstStateId == formData.state)
    .map(item => ({
      value: item.MstCityId,
      label: item.City
    }));

  citySelected.push({
    value: 0,
    label: "Others"
  });

  setBindCityDown1(citySelected);

} else {

  setBindCityDown1([]);

}

}, [formData.country, formData.state]);
console.log(formData,"Other selelcted")
  console.log("tb  before data", tableData);
  ////Bind post start
  // const villaselectchange = async (selectedRoomTypeId, rowIndex) => {
  //   //
  //   console.log("roomdetails called with:", selectedRoomTypeId, rowIndex);

  //   const updatedTableData = [...tableData];

  //   if (!updatedTableData[rowIndex]) {
  //     console.error("Invalid row index", rowIndex);
  //     return;
  //   }

  //   updatedTableData[rowIndex].RoomTypeId = selectedRoomTypeId;
  //   setTableData(updatedTableData);

  //   const { fromdate, todate } = formData;

  //   if (!fromdate || !todate) {
  //     alert("Please select both From Date and To Date.");
  //     return;
  //   }

  //   if (new Date(fromdate) > new Date(todate)) {
  //     alert("From Date cannot be after To Date.");
  //     return;
  //   }

  //   const formattedFromDate = new Date(fromdate).toISOString();
  //   const formattedToDate = new Date(todate).toISOString();

  //   try {
  //     const data = {
  //       mstRoomTypeId: selectedRoomTypeId,
  //       fromDate: formattedFromDate,
  //       toDate: formattedToDate,
  //       mstClientId: clientId,
  //     };

  //     const roomresponse = await BindPostAPI(
  //       data,
  //       "Enquiry/BindGetRoomDetails"
  //     );
  //     console.log("room", roomresponse);

  //     if (roomresponse?.data?.Table?.length > 0) {
  //       const apiRow = roomresponse.data.Table[0];

  //       updatedTableData[rowIndex] = {
  //         ...updatedTableData[rowIndex],
  //         ...apiRow,
  //       };

  //       setTableData([...updatedTableData]);
  //       console.log("tb data", tableData);
  //     } else {
  //       console.warn("No room data returned");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching available villas in date range:", error);
  //   }
  // };


  const villaselectchange = async (selectedRoomTypeId, rowIndex) => {
    console.log("roomdetails called with:", selectedRoomTypeId, rowIndex);
  
    let updatedTableData = [...tableData];
  
    if (!updatedTableData[rowIndex]) {
      console.error("Invalid row index", rowIndex);
      return;
    }
  
    // Check if this room type is already selected in other rows
    const isRoomTypeAlreadySelected = tableData.some((row, index) => 
      index !== rowIndex && row.RoomTypeId == selectedRoomTypeId
    );
  
    if (isRoomTypeAlreadySelected) {
      // Check if there are still available rooms
      const existingRow = tableData.find((row, index) => 
        index !== rowIndex && row.RoomTypeId == selectedRoomTypeId
      );
      
      if (existingRow) {
        const availableRooms = Number(existingRow.AvailableRooms) || 0;
        const alreadyBooked = tableData
          .filter((row, idx) => idx !== rowIndex && row.RoomTypeId == selectedRoomTypeId)
          .reduce((sum, row) => sum + (Number(row.Numberofrooms) || 0), 0);
        
        const remainingRooms = availableRooms - alreadyBooked;
        
        if (remainingRooms <= 0) {
          toast.error(`No available rooms left for this room type. Row will be removed.`, {
            duration: 3000,
            position: "top-center"
          });
          
          // Delete the current row since no rooms are available
          handleDeleteRow(rowIndex);
          return; // Don't proceed with selection
        }
        
        // Show warning about remaining rooms
        toast.success(`${remainingRooms} room(s) available for this room type`, {
          duration: 3000,
          position: "top-center"
        });
      }
    }
  
    updatedTableData[rowIndex].RoomTypeId = selectedRoomTypeId;
    setTableData(updatedTableData);
  
    const { fromdate, todate } = formData;
  
    if (!fromdate || !todate) {
      toast.error("Please select both From Date and To Date.", {
        duration: 3000,
        position: "top-center"
      });
      return;
    }
  
    if (new Date(fromdate) > new Date(todate)) {
      toast.error("From Date cannot be after To Date.", {
        duration: 3000,
        position: "top-center"
      });
      return;
    }
  
    const formattedFromDate = new Date(fromdate).toISOString();
    const formattedToDate = new Date(todate).toISOString();
  
    try {
      const data = {
        mstRoomTypeId: selectedRoomTypeId,
        fromDate: formattedFromDate,
        toDate: formattedToDate,
        mstClientId: clientId,
      };
  
      const roomresponse = await BindPostAPI(data, "Enquiry/BindGetRoomDetails");
      console.log("room", roomresponse);
  
      if (roomresponse?.data?.Table?.length > 0) {
        const apiRow = roomresponse.data.Table[0];
        
        // Check if there are any available rooms
        const availableRooms = Number(apiRow.AvailableRooms) || 0;
        
        if (availableRooms <= 0) {
          toast.error(`No rooms available for this room type. Row will be removed.`, {
            duration: 3000,
            position: "top-center"
          });
          
          // Delete the current row since no rooms are available
          handleDeleteRow(rowIndex);
          return;
        }
  
        updatedTableData[rowIndex] = {
          ...updatedTableData[rowIndex],
          ...apiRow,
        };
  
        setTableData([...updatedTableData]);
        console.log("tb data", tableData);
      } else {
        console.warn("No room data returned");
        toast.error(`No room details found. Row will be removed.`, {
          duration: 3000,
          position: "top-center"
        });
        
        // Delete the current row since no data returned
        handleDeleteRow(rowIndex);
      }
    } catch (error) {
      console.error("Error fetching available villas in date range:", error);
      toast.error("Error fetching room details. Row will be removed.", {
        duration: 3000,
        position: "top-center"
      });
      
      // Delete the current row on error
      handleDeleteRow(rowIndex);
    }
  };
  useEffect(() => {
  BindEnquiryTableData(); // ✅ Call the API function, not cancel()
  // cancel(); ❌ Remove this unless you actually need it after fetching
  if(onSubmit){
 cancel();
  }
 
}, [onSubmit]);

const BindEnquiryTableData = async () => {
  try {
    setIsLoading(true);

    const data = {
      MstClientId: clientId,
    };

    const response = await BindPostAPI(data, "Enquiry/BindEnquiry");

    if (response && response.data) {
      console.log("enquiry response", response);

      // ✅ Fix incorrect filter logic
      const filteredEnquiry = response.data.Table.filter(
        (item) => item.MstEnquiryStatusId === 1 || item.MstEnquiryStatusId === 2
      );

      // You were overwriting `setBindEnquiryData` twice — only keep the correct one
      setBindEnquiryData(filteredEnquiry);

      setbindenquiryChildData(
        response.data.Table1.filter((item) => item.MstEnquiryStatusId === 1)
      );

      const filteredRecords = response.data.Table.filter(
        (item) => item.BookingNo !== null && item.BookingStatus < 5  && item.MstEnquiryStatusId !== null && item.MstEnquiryStatusId === 4
      );

      setBindBookingData(filteredRecords);
      setOnSubmit(false);
    } else {
      setBindEnquiryData([]);
      setbindenquiryChildData([]);
    }
  } catch (error) {
    console.error("Error fetching enquiry data:", error);
    setBindEnquiryData([]);
    setbindenquiryChildData([]);
  } finally {
    setIsLoading(false); // ✅ Ensures loader stops even on error
  }
};

  // const handleInputChangeTable = (e, index) => {
  //   //
  //   const { name, value } = e.target;

  //   if (tableErrors[index] && tableErrors[index][name]) {
  //     const updatedErrors = [...tableErrors];
  //     updatedErrors[index] = { ...updatedErrors[index], [name]: "" };
  //     setTableErrors(updatedErrors);
  //   }
  //   const updated = [...tableData];
  //   if (name === "Numberofrooms") {
  //     const availableRooms = Number(updated[index]["AvailableRooms"]) || 0;
  //     const requestedRooms = Number(value) || 0;
      
  //     // Limit to available rooms if exceeds
  //     const finalValue = requestedRooms > availableRooms ? availableRooms : value;
  //     updated[index][name] = finalValue;
  //   } else {
  //     updated[index][name] = value;
  //   }

  //   // Parse all needed values
  //   const tariff = Number(updated[index]["Tariff"]) || 0;
  //   const specialTariff = Number(updated[index]["specialtariff"]) || 0;
  //   const numberOfRooms = Number(updated[index]["Numberofrooms"]) || 0;
  //   //const noofAdults= Number (updated[index]['noofadults']) || 0;

  //   // Example calculation (adjust as needed)
  //   updated[index]["amount"] = specialTariff*numberOfRooms ;

  //   setTableData(updated);
  //   console.log(tableData);
  // };


  // const handleInputChangeTable = (e, index) => {
  //   const { name, value } = e.target;
    
  //   // Clear errors for this specific row when user starts typing
  //   if (tableErrors.length > 0) {
  //     const updatedErrors = [...tableErrors];
  //     if (updatedErrors[index]) {
  //       // Clear the error for this specific field
  //       updatedErrors[index] = { ...updatedErrors[index], [name]: "" };
        
  //       // If all fields in this row are cleared, remove the row from errors
  //       if (Object.values(updatedErrors[index]).every(v => v === "")) {
  //         delete updatedErrors[index];
  //       }
        
  //       setTableErrors(updatedErrors);
  //     }
  //   }
    
  //   // Clear error messages for this specific row from the summary
  //   if (tableErrorMessages.length > 0) {
  //     const filteredMessages = tableErrorMessages.filter(
  //       msg => !msg.includes(`Row ${index + 1}:`)
  //     );
  //     setTableErrorMessages(filteredMessages);
  //   }
    
  //   // Update the table data
  //   const updated = [...tableData];
  //   if (name === "Numberofrooms") {
  //     const availableRooms = Number(updated[index]["AvailableRooms"]) || 0;
  //     const requestedRooms = Number(value) || 0;
      
  //     // Limit to available rooms if exceeds
  //     const finalValue = requestedRooms > availableRooms ? availableRooms : value;
  //     updated[index][name] = finalValue;
  //   } else {
  //     updated[index][name] = value;
  //   }
  
  //   // Parse all needed values
  //   const tariff = Number(updated[index]["Tariff"]) || 0;
  //   const specialTariff = Number(updated[index]["specialtariff"]) || 0;
  //   const numberOfRooms = Number(updated[index]["Numberofrooms"]) || 0;
  
  //   // Calculate amount
  //   updated[index]["amount"] = specialTariff * numberOfRooms;
  
  //   setTableData(updated);
  //   console.log(tableData);
  // };

  const handleInputChangeTable = (e, index) => {
    const { name, value } = e.target;
    
    // Clear errors for this specific row when user starts typing
    if (tableErrors.length > 0) {
      const updatedErrors = [...tableErrors];
      if (updatedErrors[index]) {
        updatedErrors[index] = { ...updatedErrors[index], [name]: "" };
        if (Object.values(updatedErrors[index]).every(v => v === "")) {
          delete updatedErrors[index];
        }
        setTableErrors(updatedErrors);
      }
    }
    
    // Clear error messages for this specific row from the summary
    if (tableErrorMessages.length > 0) {
      const filteredMessages = tableErrorMessages.filter(
        msg => !msg.includes(`Row ${index + 1}:`)
      );
      setTableErrorMessages(filteredMessages);
    }
    
    // Update the table data
    const updated = [...tableData];
    
    if (name === "Numberofrooms") {
      const availableRooms = Number(updated[index]["AvailableRooms"]) || 0;
      const requestedRooms = Number(value) || 0;
      
      // Calculate total rooms already requested for this room type across all rows
      const roomTypeId = updated[index]["RoomTypeId"];
      let totalRequestedForType = 0;
      
      if (roomTypeId) {
        updated.forEach((row, idx) => {
          if (row.RoomTypeId == roomTypeId) {
            if (idx === index) {
              totalRequestedForType += requestedRooms;
            } else {
              totalRequestedForType += Number(row.Numberofrooms) || 0;
            }
          }
        });
        
        // Validate total doesn't exceed available rooms
        if (totalRequestedForType > availableRooms) {
          const remainingRooms = availableRooms - (totalRequestedForType - requestedRooms);
          
          if (remainingRooms <= 0) {
            toast.error(`No rooms available for this room type. This row will be removed.`, {
              duration: 3000,
              position: "top-center"
            });
            
            // Delete the row if no rooms available
            setTimeout(() => {
              handleDeleteRow(index);
            }, 100); // Small delay to ensure state updates properly
            return;
          } else {
            toast.error(`Only ${remainingRooms} room(s) available for this room type`, {
              duration: 3000,
              position: "top-center"
            });
            
            // Set to remaining rooms
            updated[index][name] = remainingRooms;
          }
        } else {
          // Limit to available rooms if exceeds
          const finalValue = requestedRooms > availableRooms ? availableRooms : value;
          updated[index][name] = finalValue;
        }
      } else {
        // If no room type selected yet, just set the value
        updated[index][name] = value;
      }
    } else {
      updated[index][name] = value;
    }
  
    // Parse all needed values
    const tariff = Number(updated[index]["Tariff"]) || 0;
    const specialTariff = Number(updated[index]["specialtariff"]) || 0;
    const numberOfRooms = Number(updated[index]["Numberofrooms"]) || 0;
  
    // Calculate amount
    updated[index]["amount"] = specialTariff * numberOfRooms;
  
    setTableData(updated);
    console.log(tableData);
  };
  const validateRoomAvailability = (selectedRoomTypeId, requestedRooms, currentRowIndex) => {
    // Calculate total rooms requested for this room type across all rows
    let totalRequested = 0;
    
    tableData.forEach((row, index) => {
      if (row.RoomTypeId == selectedRoomTypeId && index !== currentRowIndex) {
        totalRequested += Number(row.Numberofrooms) || 0;
      }
    });
    
    // Add current row's requested rooms
    totalRequested += Number(requestedRooms) || 0;
    
    // Get available rooms for this room type from the current row's data
    const availableRooms = Number(tableData[currentRowIndex]?.AvailableRooms) || 0;
    
    return {
      isValid: totalRequested <= availableRooms,
      totalRequested,
      availableRooms,
      remainingRooms: availableRooms - totalRequested
    };
  };

//   const validateTableData = () => {
//   let isValid = true;
//   const errors = [];

//   tableData.forEach((row, index) => {
//     const rowErrors = {};

//     // Required dropdown (RoomTypeId)
//     if (!row.RoomTypeId) {
//       rowErrors.RoomTypeId = "Room Type is required";
//       isValid = false;
//     }

//     // AvailableRooms should be a number (optional: if not empty)
//     if (row.AvailableRooms && isNaN(row.AvailableRooms)) {
//       rowErrors.AvailableRooms = "Available Rooms must be a number";
//       isValid = false;
//     }

//     // Tariff should be a number
//     if (row.Tariff && isNaN(row.Tariff)) {
//       rowErrors.Tariff = "Tariff must be a number";
//       isValid = false;
//     }

//     // Special tariff can be optional, but if present must be a number
//     if (!row.specialtariff && isNaN(row.specialtariff)) {
//       rowErrors.specialtariff = "Special Tariff must be a number";
//       isValid = false;
//     }

//     // Number of Rooms - required and must be a number > 0
//     if (!row.Numberofrooms || isNaN(row.Numberofrooms) || parseInt(row.Numberofrooms) <= 0) {
//       rowErrors.Numberofrooms = "Number of rooms must be greater than 0";
//       isValid = false;
//     }

//     // Adults
//     if (!row.numberofadults || isNaN(row.numberofadults) || parseInt(row.numberofadults) <= 0) {
//       rowErrors.numberofadults = "Number of adults must be greater than 0";
//       isValid = false;
//     }

//     // Children
//     if (!row.numberofchildren && isNaN(row.numberofchildren)) {
//       rowErrors.numberofchildren = "Number of children must be a number";
     

//       // toast.error("Number of children must be a number", {
//       //       duration: 3000,
//       //       position: "top-center",
//       //     });
//       isValid = false;
//     }

//     // Amount – required and must be a number
//     if (!row.amount || isNaN(row.amount) || parseFloat(row.amount) <= 0) {
//       rowErrors.amount = "Amount must be a positive number";
//       isValid = false;
//     }

//     errors.push(rowErrors);
//   });

//   if (!isValid) {
//     console.log("Validation Errors:", errors);
//     // Optionally set this in state for UI display
//   }

//   return isValid;
// };
// const blockNumbers = (e) => {
//   if (/[0-9]/.test(e.key)) {
//     e.preventDefault();
//   }
// };


// const validateTableData = () => {
//   let isValid = true;
//   const errors = [];
//   const errorMessages = []; // For summary display

//   tableData.forEach((row, index) => {
//     const rowErrors = {};

//     // Required dropdown (RoomTypeId)
//     if (!row.RoomTypeId) {
//       rowErrors.RoomTypeId = "Room Type is required";
//       errorMessages.push(`Row ${index + 1}: Room Type is required`);
//       isValid = false;
//     }

//     // Number of Rooms - required and must be a number > 0
//     if (!row.Numberofrooms || isNaN(row.Numberofrooms) || parseInt(row.Numberofrooms) <= 0) {
//       rowErrors.Numberofrooms = "Required";
//       errorMessages.push(`Row ${index + 1}: Number of rooms is required`);
//       isValid = false;
//     }

//     // Adults
//     if (!row.numberofadults || isNaN(row.numberofadults) || parseInt(row.numberofadults) <= 0) {
//       rowErrors.numberofadults = "Required";
//       errorMessages.push(`Row ${index + 1}: Number of adults is required`);
//       isValid = false;
//     }

//     // Children (optional but must be number if provided)
//     if (row.numberofchildren && isNaN(row.numberofchildren)) {
//       rowErrors.numberofchildren = "Must be a number";
//       errorMessages.push(`Row ${index + 1}: Children must be a valid number`);
//       isValid = false;
//     }

//     // Special Tariff (optional but must be number if provided)
//     if (row.specialtariff && isNaN(row.specialtariff)) {
//       rowErrors.specialtariff = "Must be a number";
//       errorMessages.push(`Row ${index + 1}: Special Tariff must be a valid number`);
//       isValid = false;
//     }

//     // Amount
//     if (!row.amount || isNaN(row.amount) || parseFloat(row.amount) <= 0) {
//       rowErrors.amount = "Required";
//       errorMessages.push(`Row ${index + 1}: Amount is required`);
//       isValid = false;
//     }

//     errors[index] = rowErrors;
//   });

//   setTableErrors(errors);
//   setTableErrorMessages(errorMessages); // Store for display
//   return isValid;
// };

const validateTableData = () => {
  let isValid = true;
  const errors = [];
  const errorMessages = []; // For summary display
  
  // Track room type usage across all rows
  const roomTypeUsage = {};

  tableData.forEach((row, index) => {
    const rowErrors = {};

    // Required dropdown (RoomTypeId)
    if (!row.RoomTypeId) {
      rowErrors.RoomTypeId = "Room Type is required";
      errorMessages.push(`Row ${index + 1}: Room Type is required`);
      isValid = false;
    } else {
      // Check room availability across rows
      const roomTypeId = row.RoomTypeId;
      const requestedRooms = Number(row.Numberofrooms) || 0;
      const availableRooms = Number(row.AvailableRooms) || 0;
      
      if (!roomTypeUsage[roomTypeId]) {
        roomTypeUsage[roomTypeId] = {
          totalRequested: 0,
          availableRooms: availableRooms,
          rows: []
        };
      }
      
      roomTypeUsage[roomTypeId].totalRequested += requestedRooms;
      roomTypeUsage[roomTypeId].rows.push(index + 1);
    }

    // Number of Rooms - required and must be a number > 0
    if (!row.Numberofrooms || isNaN(row.Numberofrooms) || parseInt(row.Numberofrooms) <= 0) {
      rowErrors.Numberofrooms = "Required";
      errorMessages.push(`Row ${index + 1}: Number of rooms is required`);
      isValid = false;
    }

    // Adults
    if (!row.numberofadults || isNaN(row.numberofadults) || parseInt(row.numberofadults) <= 0) {
      rowErrors.numberofadults = "Required";
      errorMessages.push(`Row ${index + 1}: Number of adults is required`);
      isValid = false;
    }

    // Children (optional but must be number if provided)
    if (row.numberofchildren && isNaN(row.numberofchildren)) {
      rowErrors.numberofchildren = "Must be a number";
      errorMessages.push(`Row ${index + 1}: Children must be a valid number`);
      isValid = false;
    }

    // Special Tariff (optional but must be number if provided)
    if (row.specialtariff && isNaN(row.specialtariff)) {
      rowErrors.specialtariff = "Must be a number";
      errorMessages.push(`Row ${index + 1}: Special Tariff must be a valid number`);
      isValid = false;
    }

    // Amount
    if (!row.amount || isNaN(row.amount) || parseFloat(row.amount) <= 0) {
      rowErrors.amount = "Required";
      errorMessages.push(`Row ${index + 1}: Amount is required`);
      isValid = false;
    }

    errors[index] = rowErrors;
  });
  
  // Validate total requested rooms don't exceed available for each room type
  Object.keys(roomTypeUsage).forEach(roomTypeId => {
    const usage = roomTypeUsage[roomTypeId];
    if (usage.totalRequested > usage.availableRooms) {
      errorMessages.push(
        `Room Type (${roomTypeId}): Total requested (${usage.totalRequested}) exceeds available (${usage.availableRooms}) rooms in rows ${usage.rows.join(', ')}`
      );
      isValid = false;
    }
  });

  setTableErrors(errors);
  setTableErrorMessages(errorMessages); // Store for display
  return isValid;
};
const blockNumbers = (e) => {
     if (/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
   };


  return (
    <MainLayout pageName={"3"}>
      <div ref={topRef}></div>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title={"Enquiry"}
          header={enquiryHeaders}
          records={bindEnquiryData}
          showAdd={showAdd}
          handleAction={handleState}
          handleEdit={handleEdit}
          onConfirmBooking={onConfirmBooking}
          onLostEnquiry={onLostEnquiry}
          onHoldEnquiry={onHoldEnquiry}
        />
      )}

      {visibleTable && (
        <GridPage
          title={"Booking Details"}
          header={BookingDetailsHeaders}
          records={bindBookingData}
          showAdd={showAdd}
          CancelledBookingsBtn={true}
          addbtnView={false}
          handleAction={onViewEnquiry}
          // handleAction={handleBookingEdit}
          handleEdit={handleBookingEdit}
          onConfirmBooking={onConfirmBooking}
          onLostEnquiry={onLostEnquiry}
          onHoldEnquiry={onHoldEnquiry}
          onCancelEnquiry={onCancelEnquiry}
        />
      )}

      {visibleAdd && (
        <>
          <AddScreenTitle
            addScreenTitle={addScreenTitle}
            updateScreenTitle={updateScreenTitle}
            title="Enquiry Form"
          />
          <div>
            <div className="mx-auto p-8 maxw-7xl">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 ">
                <InputText
                  inputType="text"
                  title="Enquiry ID"
                  name="enquiryid"
                  controlFunc={handleInputChangeForm}
                  controlFuncBlur={handleBlur}
                  content={formData.enquiryid}
                  placeholder=""
                  disabled={true}
                  // // tabIndex="11"
                  isRequired={true}
                  // errorMessage={errors.enquiryid}
                />

                <InputText
                  inputType="date"
                  title="Enquiry date"
                  name="enquirydate"
                  controlFunc={handleInputChangeForm}
                  controlFuncBlur={handleBlur}
                  content={today}
                  placeholder="dd/mm/yyyy"
                  disabled={false}
                  // // tabIndex="9"
                  isRequired={true}
                  //errorMessage={errors.enquirydate}
                />
                <DropDown
                  name="enquirytype"
                  title="Enquiry Type"
                  type={"select-one"}
                  options={enquirytypedropdown}
                  selectedOption={
                    formData.enquirytype != 0 ? formData.enquirytype : ""
                  }
                  controlFunc={handleInputChangeForm}
                  controlFuncBlur={handleBlur}
                  placeholder="Select Enquiry Type"
                  // // tabIndex="12"
                  isRequired={true}
                  errorMessage={errors.enquirytype}
                  classStar="text-red-500"
                />

                <InputText
                  inputType="date"
                  title="Booking From"
                  name="fromdate"
                  controlFunc={handleInputChangeForm}
                  controlFuncBlur={handleBlur}
                  content={formData.fromdate}
                  placeholder="Enter Date"
                  disabled={false}
                  // // tabIndex="9"
                  isRequired={true}
                  errorMessage={errors.fromdate}
                  classStar="text-red-500"
                  min={new Date().toISOString().split("T")[0]} // ✅ Restrict past dates
                />
                <InputText
                  inputType="date"
                  title="Booking To"
                  name="todate"
                  controlFunc={handleInputChangeForm}
                  controlFuncBlur={handleBlur}
                  content={formData.todate}
                  placeholder="Enter Date"
                  disabled={false}
                  // // tabIndex="9"
                  isRequired={true}
                  errorMessage={errors.todate}
                  classStar="text-red-500"
                  min={new Date().toISOString().split("T")[0]} // ✅ Restrict past dates
                />

                <InputText
                  inputType="text"
                  title="Number of Days"
                  name="noofdays"
                  controlFunc={handleInputChangeForm}
                  controlFuncBlur={handleBlur}
                  content={formData.noofdays}
                  placeholder="No Of Days"
                  disabled={true}
                  // // tabIndex="3"
                  isRequired={true}
                  errorMessage={errors.noofdays}
                />

                <InputText
                  inputType="text"
                  title="First Name"
                  name="fname"
                  controlFunc={handleInputChangeForm}
                  controlFuncBlur={handleBlur}
                  content={formData.fname}
                  placeholder="Enter your first name"
                  disabled={false}
                  // // tabIndex="1"
                  isRequired={true}
                  errorMessage={errors.fname}
                  onKeyDown={blockNumbers}
                  classStar="text-red-500"
                />

                <InputText
                  inputType="text"
                  title="Last Name"
                  name="lname"
                  controlFunc={handleInputChangeForm}
                  // controlFuncBlur={handleBlur}
                  content={formData.lname}
                  placeholder="Enter your last name"
                  disabled={false}
                  // // tabIndex="2"
                  isRequired={true}
                  onKeyDown={blockNumbers}
                  errorMessage={errors.lname}
                />

                <InputText
                  inputType="text"
                  title="Mobile Number"
                  name="number"
                  controlFunc={handleInputChangeForm}
                  controlFuncBlur={handleBlur}
                  content={formData.number}
                  placeholder="Enter your mobile number"
                  disabled={false}
                  // // tabIndex="3"
                  isRequired={true}
                  errorMessage={errors.number}
                  classStar="text-red-500"
                  maxLength={15}
                />

                <AutoDropDown
                  name="country"
                  title="Country"
                  placeholder="Select country"
                  // // tabIndex="5"
                  isRequired={true}
                  disabled={false}
                  options={countrydropdown}
                  content={formData.country}
                  controlFunc={(value, e) => {
                    handleUserFieldsChange(value.value, e.name);
                  }}
                  controlFuncBlur={handleBlur}
                  selectedOption={
                    formData.country
                      ? countrydropdown.find((x) => x.value == formData.country)
                      : ""
                  }
                  Class="custom-class"
                />

                <AutoDropDown
                  name="state"
                  title="State"
                  placeholder="Select state"
                  options={bindStateDown1}
                  // // tabIndex="1"
                  isRequired={true}
                  //disabled={false}
                  content={formData.state}
                  controlFunc={(value, e) => {
                    handleUserFieldsChange(value.value, e.name);
                  }}
                  controlFuncBlur={handleBlur}
                  selectedOption={
                    formData.state
                      ? bindStateDown1.find((x) => x.value == formData.state)
                      : ""
                  }
                  Class="custom-class"
                  disabled={formData.state===0 }
                />

             

                <AutoDropDown
                  name="city"
                  title="City"
                  options={bindCityDown1}
                  selectedOption={
                    formData.city
                      ? bindCityDown1.find((x) => x.value == formData.city)
                      : ""
                  }
                  controlFunc={(value, e) => {
                    handleUserFieldsChange(value.value, e.name);
                  }}
                  controlFuncBlur={handleBlur}
                  placeholder="Select City"
                  // // tabIndex="12"
                  errorMessage={errors.city}
                  Class="custom-class"
                  disabled={formData.state==0 || formData.city ==0}
                />

              {formData.state== 0 && (<InputText
                  inputType="text"
                  title="State Name"
                  name="statename"
                  controlFunc={handleInputChangeForm}
                  controlFuncBlur={handleBlur}
                  content={formData.statename}
                  placeholder="Enter the State Name"
                  disabled={false}
                  // // tabIndex="3"
                  isRequired={true}
                  errorMessage={errors.statename}
                  classStar="text-red-500"
                  maxLength={15}
                />)}   

                {(formData.state== 0  || formData.city==0)&& (<InputText
                  inputType="text"
                  title="City Name"
                  name="cityname"
                  controlFunc={handleInputChangeForm}
                  controlFuncBlur={handleBlur}
                  content={formData.cityname}
                  placeholder="Enter the City Name"
                  disabled={false}
                  // // tabIndex="3"
                  isRequired={true}
                  errorMessage={errors.cityname}
                  classStar="text-red-500"
                  maxLength={15}
                />)} 


                <InputText
                  inputType="text"
                  title="Door No & Street name"
                  name="streetdoorno"
                  content={formData.streetdoorno}
                  controlFunc={handleInputChangeForm}
                  controlFuncBlur={handleBlur}
                  placeholder="Enter city"
                  disabled={false}
                  // // tabIndex="8"
                  isRequired={true}
                  //content={formData.city}
                />

                <InputText
                  inputType="text"
                  title="Area"
                  name="area"
                  controlFunc={handleInputChangeForm}
                  controlFuncBlur={handleBlur}
                  placeholder="Enter Area"
                  disabled={false}
                  // // tabIndex="9"
                  isRequired={true}
                  content={formData.area}
                />

                <InputText
                  inputType="text"
                  title="Pincode"
                  name="pincode"
                  controlFunc={handleInputChangeForm}
                  controlFuncBlur={handleBlur}
                  placeholder="Enter pincode"
                  disabled={false}
                  // // tabIndex="11"
                  isRequired={true}
                  content={formData.pincode}
                />

                <div className="text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500">
                  <DropDown
                    name="sourcetype"
                    title="Source Type"
                    type={"select-one"}
                    options={referralsource}
                    selectedOption={
                      formData.sourcetype != 0 ? formData.sourcetype : ""
                    }
                    controlFunc={handleInputChangeForm}
                    controlFuncBlur={handleBlur}
                    placeholder="Select Source type"
                    // // tabIndex="12"
                    errorMessage={errors.referralsource}
                  />
                </div>

                <InputText
                  inputType="text"
                  title="Source"
                  name="source"
                  controlFunc={handleInputChangeForm}
                  controlFuncBlur={handleBlur}
                  content={formData.source}
                  placeholder="Enter Name"
                  disabled={false}
                  // // tabIndex="9"
                  isRequired={true}
                  errorMessage={errors.ReferralPerson}
                />

                <InputText
                  inputType="text"
                  title="Contact Number"
                  name="referralcontact"
                  controlFunc={handleInputChangeForm}
                  controlFuncBlur={handleBlur}
                  content={formData.referralcontact}
                  placeholder="Enter Number"
                  disabled={false}
                  // // tabIndex="9"
                  maxLength={15}
                  isRequired={true}
                  errorMessage={errors.ReferralContactNumber}
                />
                <div className="text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500">
                  <DropDown
                    name="idproof"
                    title="ID-Proof"
                    type={"select-one"}
                    options={iddropdown}
                    selectedOption={
                      formData.idproof != 0 ? formData.idproof : ""
                    }
                    controlFunc={handleInputChangeForm}
                    controlFuncBlur={handleBlur}
                    placeholder="Select ID-Proof"
                    // // tabIndex="12"
                    errorMessage={errors.idproof}
                  />
                </div>

                <InputText
                  inputType="text"
                  title="ID-Number"
                  name="idvalue"
                  controlFunc={handleInputChangeForm}
                  controlFuncBlur={handleBlur}
                  content={formData.idvalue}
                  placeholder="Enter ID-Number"
                  disabled={false}
                  // // tabIndex="9"
                  isRequired={true}
                  errorMessage={errors.idvalue}
                />
                  <InputText
                  inputType="text"
                  title="E-mail"
                  name="email"
                  controlFunc={handleInputChangeForm}
                  controlFuncBlur={handleBlur}
                  content={formData.email}
                  placeholder="Enter E-mail"
                  disabled={false}
                  // // tabIndex="9"
                  isRequired={true}

                />
              </div>
              <div></div>
              <div className=" mx-auto grid-cols-3 p-8 maxw-7xl"></div>

              <table className="min-w-full table-auto border border-gray-300 ">
                <thead className="bg-[#3D6643] text-white text-left">
                  <tr>
                    <th className="border px-2 py-2 w-[30px]">SN</th>
                    <th className="border px-4 py-2 w-[270px]">Room Type</th>
                    <th className="border px-4 py-2 w-[30px]">
                      Available Rooms
                    </th>
                    <th className="border px-4 py-2 w-[160px]">Basic Tariff</th>
                    <th className="border px-4 py-2 w-[160px]">Spl. Tariff</th>
                    <th className="border px-4 py-2 w-[100px]">No. Of rooms</th>
                    <th className="border px-2 py-2 w-[80px]">No. Of Adults</th>
                    <th className="border px-2 py-2 w-[80px]">
                      No. Of Children
                    </th>
                    <th className="border px-2 py-2 w-[150px]">Amount</th>
                    <th className="border px-4 py-2 w-[80px]">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((room, index) => (
                    <tr key={index}>
                      <td className="border px-2 py-2">{index + 1}</td>

                      <td className="border px-4 py-2">
                        <DropDown
                          name="RoomTypeId"
                          options={roomtype}
                          //onChange={(value) => bothFunc(value)}

                          //selectedOption={room.Villatype}
                          controlFunc={(e) => {
                            handleInputChangeTable(e, index);

                            villaselectchange(e.target.value, index);
                          }}
                          selectedOption={room.RoomTypeId || ""}
                          controlFuncBlur={handleBlur}
                          placeholder={"Select Room Type"}
                        />
                      </td>
                      <td className="border px-4 py-2 ">
                        <InputText
                          className="text-right"
                          name="AvailableRooms"
                          disabled={true}
                          content={room.AvailableRooms || ""}
                          controlFunc={(e) => handleInputChangeTable(e, index)}
                        />
                      </td>
                      <td className="border px-4 py-2 ">
                        <InputText
                          className="text-right"
                          name="Tariff"
                          content={room.Tariff || ""}
                          disabled={true}
                          controlFunc={(e) => handleInputChangeTable(e, index)}
                        />
                      </td>
                      <td className="border px-4 py-2 ">
                        <InputText
                          name="specialtariff"
                          content={room.specialtariff || ""}
                          controlFunc={(e) => handleInputChangeTable(e, index)}
                          className="text-right"
                        />
                      </td>
                      <td className="border px-4 py-2 ">
                        <InputText
                          className="text-right"
                          name="Numberofrooms"
                          max={room.AvailableRooms} 
                          content={room.Numberofrooms || ""}
                          controlFunc={(e) => handleInputChangeTable(e, index)}
                        />
                      </td>
                      <td className="border px-2 py-2 ">
                        <InputText
                          className="text-right"
                          name="numberofadults"
                          content={room.numberofadults || ""}
                          controlFunc={(e) => handleInputChangeTable(e, index)}
                        />
                      </td>
                      <td className="border px-2 py-2 text-right">
                        <InputText
                          className="text-right"
                          name="numberofchildren"
                          content={room.numberofchildren || ""}
                          controlFunc={(e) => handleInputChangeTable(e, index)}
                        />
                      </td>
                      <td className="border px-2 py-4 text-right">
                        <InputText
                          className="border px-2 py-4 text-right"
                          name="amount"
                          content={tableData[index].amount || 0}
                          disabled={false}
                          controlFunc={(e) => handleInputChangeTable(e, index)}
                        />
                      </td>
                      <td className="border px-4 py-2">
                        <div className="flex gap-4 items-center justify-center">
                          <svg
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            className="w-6 h-6 text-black cursor-pointer"
                            onClick={() => handleDeleteRow(index)}
                          >
                            <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                          </svg>
                          {index === tableData.length - 1 &&
                            tableData.length && (
                              <svg
                                viewBox="0 0 1024 1024"
                                fill="currentColor"
                                onClick={handleAddRow}
                                className="w-6 h-6 text-black cursor-pointer"
                              >
                                <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                              </svg>
                            )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {/*  table end */}

              {tableErrorMessages.length > 0 && (
 

    <ul className="flex flex-wrap gap-4">
      {tableErrorMessages.map((message, index) => (
        <li
          key={index}
          className="text-red-500 text-sm font-medium"
        >
          {message}
        </li>
      ))}
    </ul>
 
)}

              <div className="mx-auto p-4 max-w-7xl">
                <ul className="space-y-4">
                  {tableData
                    ?.filter((room) => room.RoomTypeId) // only rows where a room type is selected
                    .map((room, index) => (
                      <li
                        key={index}
                        className="border border-green-500 rounded-md p-4 shadow-sm bg-white"
                      >
                        <div className="flex flex-col  items-start  justify-between ">
                          {/* Checkbox & Button */}
                          <h2 className="text-lg font-semibold text-gray-800 mb-2">
                            {room.RoomName}
                          </h2>
                          <div className="flex flex-col md:flex-row items-start md:gap-x-10">
                            {/* Villa Image */}
                            <img
                              src={room.Photo}
                              alt="Room"
                              className="h-36 w-36 object-cover rounded-md border"
                            />
                            <div>
                              {/* Villa Info */}
                              <div className="flex-1 flex-col w-full">
                                <div className="flex flex-col md:flex-row md:gap-x-24 flex-1">
                                  {/* Left Column */}
                                  <div className="flex-2 space-y-1">
                                    <p className="text-sm text-gray-600">
                                      Property Size:{room.Size}
                                    </p>
                                    <p className="text-sm text-gray-600">
                                      Maximum Occupancy: {room.MaxOccupancy}
                                    </p>
                                    <p className="text-sm text-gray-600">
                                      Room Type:{room.RoomType}
                                    </p>
                                  </div>

                                  {/* Center Column */}
                                  <div className="flex-2 space-y-1">
                                    {room.SpaceDetails ? (
                                      <ul className="text-sm text-gray-600">
                                        {room.SpaceDetails.split(",").map(
                                          (item, idx) => (
                                            <li key={idx}>
                                              {idx + 1}. {item.trim()}
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    ) : (
                                      <p className="text-sm text-gray-600">
                                        Space Details: Not Available
                                      </p>
                                    )}
                                  </div>

                                  {/* Right Column */}
                                  <div className="flex-2 space-y-1">
                                    {room.AmenitiesDetails ? (
                                      <ul className="text-sm text-gray-600 ">
                                        {room.AmenitiesDetails.split(",").map(
                                          (item, idx) => (
                                            <li key={idx}>
                                              {idx + 1}. {item.trim()}
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    ) : (
                                      <p className="text-sm text-gray-600">
                                        Amenities Details: Not Available
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div className="">
                                  <p className="text-sm font-semibold text-gray-700 mb-2">
                                    Rooms: {room.AvailableRooms}
                                  </p>

                                  <div className="grid grid-cols-6 gap-2">
  {(room.AvailableRoomsName || "")
    .split(",")
    .map((roomName, index) => (
      <button
        key={index}
        className="px-3 py-2 text-sm font-medium rounded-2xl text-white bg-green-500 hover:bg-green-600"
      >
        {roomName.trim()}
      </button>
    ))}
</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>

              <div className={mainTable.grid3}>
                <InputText
                  inputType="text"
                  title="Total Amount"
                  name="amountpaid"
                  controlFunc={handleInputChange}
                  controlFuncBlur={handleBlur}
                  content={formData.amountpaid}
                  //content={"32000"}
                  placeholder="Enter Book Amount"
                  errorMessage={errors.bookamount}
                  disabled={true}
                  isRequired={true}
                  // // tabIndex="11"
                />
               
              </div>
            </div>

            <div className="px-4 py-2"></div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 "></div>
          </div>
          {/* Submit Button */}
          <div className="flex justify-center gap-4  mt-6">
            <Buttons
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              handleSubmit={handleSubmit}
              cancel={cancel}
              disabledBtn={submitBtnDisabled}
              onBooking={() => onConfirmBookingSubmit(0, confirmBookingFlag)}
             // onHold={() => onHoldEnquiry(0, 1)}
              onLost={() => onLostEnquiry(0, 1)}
            />
          </div>
        </>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}

      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleState}
      >
        <div>
          <PopUpScreenTitle
            title="Enquiry"
            // hederDetails={true}
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <Enquirypopup
            data={selectedRecord}
            data1={popUpData}
            data2={tableData}
          />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>

      <MainPopup
        popUpOpen={popUpBookOpen}
        setpopUpOpen={setpopUpBookOpen}
        Open={onConfirmBooking}
      >
        <div>
          <PopUpScreenTitle
            title={
              viewPopUp ? "Booking Confirmation - Edit" : "Booking Confirmation"
            }
            setpopUpOpen={setpopUpBookOpen}
            hederDetails={setpopUpBookOpen}
          />
          <ConfirmBookingPopUp
            data={confirm}
            data1={confirm1}
            data2={tableData}
            data3={confirm2}
            isOpen={setpopUpBookOpen}
            isSubmit={setOnSubmit}
            viewPopUp={viewPopUp}
          />
        </div>
      </MainPopup>

      <MainPopup
        popUpOpen={popUpLostOpen}
        setpopUpOpen={setpopUpLostOpen}
        Open={onLostEnquiry}
      >
        <div>
          <PopUpScreenTitle
            title="On Lost"
            headerDetails={setpopUpLostOpen}
            setpopUpOpen={setpopUpLostOpen}
            viewDetails={setpopUpLostOpen}
          />
          <OnLostPopUp
            data={lostRecord}
            data1={lostTableData}
            isOpen={setpopUpLostOpen} //  to import lost enquiry popup component
            isSubmit={setOnSubmit}
          />
        </div>
      </MainPopup>

      <MainPopup
        popUpOpen={popUpHoldOpen}
        setpopUpOpen={setpopUpHoldOpen}
        Open={onHoldEnquiry}
      >
        <div>
          <PopUpScreenTitle
            title="On Hold"
            setpopUpOpen={setpopUpHoldOpen}
            viewDetails={setpopUpHoldOpen}
          />
          <OnHoldPopUp
            data={holdrecord} //  to import Hold enquiry popup component
          />
        </div>
      </MainPopup>
      <MainPopup
        popUpOpen={popUpCancelOpen}
        setpopUpOpen={setpopUpCancelOpen}
        Open={onCancelEnquiry}
      >
        <div>
          <PopUpScreenTitle
            hederDetails={true}
            title={viewPopUp ? "Booking Confirmation - View" : "On Cancel"}
            setpopUpOpen={setpopUpCancelOpen}
            headerDetails={setpopUpCancelOpen}
          />
          <Cancelpopup
            data={confirm}
            data1={confirm1}
            data2={tableData}
            data3={confirm2}
            isOpen={setpopUpCancelOpen}
            isSubmit={setOnSubmit}
            viewPopUp={viewPopUp}
          />
          <PopUpButtons
      viewDetails={viewPopUp}
      deleteDetails={false}
      blockDetails={false}
      unBlockDetails={false}
      rowIndex={rowIndex}
      handleSubmit={handleSubmit}
      cancel={cancel}
      cancelBtn={viewPopUp ? false : true}
      disabledBtn={submitBtnDisabled}
    />
        </div>
      </MainPopup>
    </MainLayout>
  );
};
export default Enquiry;
